// // import React, { useState, useEffect } from 'react';
// // import { ChevronLeft, ChevronRight, Menu, X } from 'lucide-react';

// // const PremiumWebsite = () => {
// //   const [currentSlide, setCurrentSlide] = useState(0);
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);

// //   // Sample portfolio images - replace with your actual work
// //   const portfolioItems = [
// //     {
// //       id: 1,
// //       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop",
// //       title: "E-commerce Platform",
// //       category: "Web Development"
// //     },
// //     {
// //       id: 2,
// //       image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&h=500&fit=crop",
// //       title: "Mobile Banking App",
// //       category: "Mobile Development"
// //     },
// //     {
// //       id: 3,
// //       image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=500&fit=crop",
// //       title: "Brand Identity Design",
// //       category: "Branding"
// //     },
// //     {
// //       id: 4,
// //       image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800&h=500&fit=crop",
// //       title: "SaaS Dashboard",
// //       category: "UI/UX Design"
// //     },
// //     {
// //       id: 5,
// //       image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=500&fit=crop",
// //       title: "Analytics Platform",
// //       category: "Data Visualization"
// //     }
// //   ];

// //   // Auto-slide functionality
// //   useEffect(() => {
// //     const timer = setInterval(() => {
// //       setCurrentSlide((prev) => (prev + 1) % portfolioItems.length);
// //     }, 4000);

// //     return () => clearInterval(timer);
// //   }, [portfolioItems.length]);

// //   const nextSlide = () => {
// //     setCurrentSlide((prev) => (prev + 1) % portfolioItems.length);
// //   };

// //   const prevSlide = () => {
// //     setCurrentSlide((prev) => (prev - 1 + portfolioItems.length) % portfolioItems.length);
// //   };

// //   return (
// //     <div className="min-h-screen bg-white">
// //       {/* Enhanced Header with White Background - Combined Navigation & Works */}
// //       <header className="relative min-h-screen bg-white overflow-hidden">
// //         {/* Animated Background Elements */}
// //         <div className="absolute inset-0">
// //           {/* Large Floating Orbs */}
// //           <div className="absolute top-10 left-10 w-96 h-96 bg-gradient-to-r from-pink-200 to-violet-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse"></div>
// //           <div className="absolute top-20 right-20 w-80 h-80 bg-gradient-to-r from-cyan-200 to-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" style={{ animationDelay: '1s' }}></div>
// //           <div className="absolute bottom-20 left-1/3 w-72 h-72 bg-gradient-to-r from-orange-200 to-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" style={{ animationDelay: '2s' }}></div>
// //           <div className="absolute bottom-40 right-10 w-64 h-64 bg-gradient-to-r from-emerald-200 to-teal-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" style={{ animationDelay: '3s' }}></div>

// //           {/* Floating Geometric Shapes */}
// //           <div className="absolute top-32 left-1/4 w-8 h-8 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full animate-bounce opacity-40" style={{ animationDelay: '0.5s' }}></div>
// //           <div className="absolute top-1/3 right-1/4 w-6 h-6 bg-gradient-to-r from-pink-400 to-red-400 transform rotate-45 animate-spin opacity-40" style={{ animationDuration: '6s' }}></div>
// //           <div className="absolute bottom-1/3 left-1/2 w-4 h-4 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full animate-ping opacity-40" style={{ animationDelay: '1.5s' }}></div>
// //           <div className="absolute top-2/3 left-1/3 w-10 h-10 bg-gradient-to-r from-blue-400 to-indigo-400 transform rotate-12 animate-bounce opacity-40" style={{ animationDelay: '2.5s' }}></div>

// //           {/* Grid Pattern Overlay */}
// //           <div className="absolute inset-0 opacity-5" style={{
// //             backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Cpath d='M0 0h20v20H0zM20 20h20v20H20z'/%3E%3C/g%3E%3C/svg%3E")`
// //           }}></div>
// //         </div>

// //         {/* Navigation Bar with Integrated Slides */}
// //         <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-b border-gray-200 shadow-lg">
// //           <div className="max-w-7xl mx-auto px-6 py-4">
// //             {/* Top Row - Logo and Navigation */}
// //             <div className="flex items-center justify-between mb-4">
// //               {/* Logo */}
// //               <div className="flex items-center space-x-3">
// //                 <div className="w-12 h-12 bg-gradient-to-r from-violet-500 to-indigo-500 rounded-2xl flex items-center justify-center shadow-xl animate-pulse">
// //                   <span className="text-white font-bold text-xl">K</span>
// //                 </div>
// //                 <span className="text-3xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 bg-clip-text text-transparent">
// //                   Konnectify
// //                 </span>
// //               </div>

// //               {/* Desktop Navigation */}
// //               <div className="hidden md:flex items-center space-x-8">
// //                 <a href="#home" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //                   Home
// //                 </a>
// //                 <a href="#services" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //                   Services
// //                 </a>
// //                 <a href="#clients" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //                   Clients
// //                 </a>
// //                 <a href="#contact" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //                   Contact
// //                 </a>
// //                 <button className="bg-gradient-to-r from-violet-500 to-indigo-500 text-white px-8 py-3 rounded-full hover:shadow-2xl transform hover:scale-105 transition-all duration-300 shadow-lg">
// //                   Get Started
// //                 </button>
// //               </div>

// //               {/* Mobile Menu Button */}
// //               <button 
// //                 className="md:hidden text-gray-700"
// //                 onClick={() => setIsMenuOpen(!isMenuOpen)}
// //               >
// //                 {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
// //               </button>
// //             </div>

// //             {/* Works Slider Integrated in Header */}
// //             <div className="relative">
// //               <div className="flex items-center justify-between mb-3">
// //                 <h2 className="text-xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 bg-clip-text text-transparent">
// //                   Our Latest Works
// //                 </h2>
// //                 <div className="flex space-x-2">
// //                   <button 
// //                     onClick={prevSlide}
// //                     className="w-8 h-8 bg-violet-100 hover:bg-violet-200 text-violet-600 rounded-full flex items-center justify-center transition-all"
// //                   >
// //                     <ChevronLeft size={16} />
// //                   </button>
// //                   <button 
// //                     onClick={nextSlide}
// //                     className="w-8 h-8 bg-violet-100 hover:bg-violet-200 text-violet-600 rounded-full flex items-center justify-center transition-all"
// //                   >
// //                     <ChevronRight size={16} />
// //                   </button>
// //                 </div>
// //               </div>

// //               {/* Horizontal Slides in Header */}
// //               <div className="flex space-x-4 overflow-hidden">
// //                 {portfolioItems.map((item, index) => (
// //                   <div 
// //                     key={item.id}
// //                     className={`relative flex-shrink-0 w-32 h-20 rounded-xl overflow-hidden border-2 transition-all duration-500 cursor-pointer ${
// //                       index === currentSlide 
// //                         ? 'border-violet-500 shadow-lg scale-105' 
// //                         : 'border-gray-200 hover:border-gray-300'
// //                     }`}
// //                     onClick={() => setCurrentSlide(index)}
// //                   >
// //                     <img 
// //                       src={item.image} 
// //                       alt={item.title}
// //                       className="w-full h-full object-cover"
// //                     />
// //                     <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
// //                     <div className="absolute bottom-1 left-2 right-2">
// //                       <h4 className="text-white text-xs font-semibold truncate">{item.title}</h4>
// //                       <p className="text-white/80 text-xs truncate">{item.category}</p>
// //                     </div>
// //                     {index === currentSlide && (
// //                       <div className="absolute top-2 right-2">
// //                         <div className="w-2 h-2 bg-violet-500 rounded-full animate-pulse"></div>
// //                       </div>
// //                     )}
// //                   </div>
// //                 ))}
// //               </div>

// //               {/* Slide Indicators */}
// //               <div className="flex justify-center space-x-2 mt-3">
// //                 {portfolioItems.map((_, index) => (
// //                   <button
// //                     key={index}
// //                     onClick={() => setCurrentSlide(index)}
// //                     className={`w-2 h-2 rounded-full transition-all ${
// //                       index === currentSlide 
// //                         ? 'bg-violet-500 w-6' 
// //                         : 'bg-gray-300 hover:bg-gray-400'
// //                     }`}
// //                   />
// //                 ))}
// //               </div>
// //             </div>

// //             {/* Mobile Navigation */}
// //             {isMenuOpen && (
// //               <div className="md:hidden mt-6 pb-6 border-t border-gray-200">
// //                 <nav className="flex flex-col space-y-4 pt-6">
// //                   <a href="#home" className="text-gray-700 hover:text-violet-600 font-medium">Home</a>
// //                   <a href="#services" className="text-gray-700 hover:text-violet-600 font-medium">Services</a>
// //                   <a href="#clients" className="text-gray-700 hover:text-violet-600 font-medium">Clients</a>
// //                   <a href="#contact" className="text-gray-700 hover:text-violet-600 font-medium">Contact</a>
// //                   <button className="bg-gradient-to-r from-violet-500 to-indigo-500 text-white px-8 py-3 rounded-full w-fit shadow-lg">
// //                     Get Started
// //                   </button>
// //                 </nav>
// //               </div>
// //             )}
// //           </div>
// //         </nav>

// //         {/* Combined Header Content */}
// //         <div className="relative z-10 max-w-7xl mx-auto px-6 pt-48 pb-16">
          
// //           {/* Main Content based on Current Slide */}
// //           <div className="text-center mb-16">
// //             <div className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-violet-50 to-indigo-50 border border-violet-200 rounded-full mb-10 shadow-xl animate-pulse">
// //               <span className="text-violet-700 text-base font-semibold">✨ Branding Irreversible ✨</span>
// //             </div>
            
// //             <h1 className="text-6xl lg:text-7xl font-bold leading-tight mb-8">
// //               <span className="block text-gray-900 mb-4">Featured Project:</span>
// //               <span className="block bg-gradient-to-r from-violet-600 via-pink-600 to-cyan-600 bg-clip-text text-transparent animate-pulse">
// //                 {portfolioItems[currentSlide].title}
// //               </span>
// //             </h1>
            
// //             <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-12">
// //               {portfolioItems[currentSlide].category} - Innovative design meets cutting-edge technology to deliver exceptional user experiences with modern aesthetics and functionality
// //             </p>
// //           </div>

// //           {/* Large Featured Work Display */}
// //           <div className="relative max-w-5xl mx-auto">
// //             <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-2xl bg-white border border-gray-200 transform hover:scale-105 transition-all duration-700">
// //               <img 
// //                 src={portfolioItems[currentSlide].image} 
// //                 alt={portfolioItems[currentSlide].title}
// //                 className="w-full h-full object-cover transition-all duration-700"
// //               />
              
// //               {/* Content Overlay */}
// //               <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
// //               <div className="absolute bottom-0 left-0 right-0 p-8">
// //                 <div className="flex items-end justify-between">
// //                   <div>
// //                     <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-violet-500 to-pink-500 text-white text-sm font-bold rounded-full mb-4 shadow-lg">
// //                       {portfolioItems[currentSlide].category}
// //                     </div>
// //                     <h3 className="text-3xl lg:text-4xl font-bold text-white mb-3">{portfolioItems[currentSlide].title}</h3>
// //                     <p className="text-white/90 text-lg max-w-2xl leading-relaxed mb-6">
// //                       Exceptional user experience designed with modern technologies and innovative approaches to solve real business challenges.
// //                     </p>
// //                     <div className="flex gap-4">
// //                       <button className="bg-gradient-to-r from-white to-gray-100 text-gray-900 px-8 py-3 rounded-full font-bold hover:shadow-xl transition-all transform hover:scale-110 hover:-translate-y-1 duration-300">
// //                         View Project
// //                       </button>
// //                       <button className="bg-gradient-to-r from-violet-500 to-pink-500 text-white px-8 py-3 rounded-full font-bold hover:shadow-xl transition-all transform hover:scale-110 hover:-translate-y-1 duration-300">
// //                         Live Demo
// //                       </button>
// //                     </div>
// //                   </div>
                  
// //                   <div className="hidden lg:block text-right">
// //                     <div className="text-6xl font-bold text-white/30">
// //                       {String(currentSlide + 1).padStart(2, '0')}
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Call to Action */}
// //             <div className="text-center mt-16">
// //               <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
// //                 <button className="bg-gradient-to-r from-violet-500 via-purple-500 to-pink-500 text-white px-16 py-4 rounded-full font-bold text-lg hover:shadow-2xl transform hover:scale-110 hover:-translate-y-2 transition-all duration-300 shadow-xl">
// //                   Start Your Project
// //                 </button>
// //                 <button className="bg-gradient-to-r from-gray-50 to-gray-100 border-2 border-gray-200 text-gray-700 px-16 py-4 rounded-full font-bold text-lg hover:shadow-xl hover:border-gray-300 transition-all duration-300 transform hover:scale-110 hover:-translate-y-2">
// //                   View All Works
// //                 </button>
// //               </div>
              
// //               {/* Stats Cards */}
// //               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-12">
// //                 <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-violet-50 to-indigo-50 border border-violet-200 hover:shadow-xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2">
// //                   <div className="text-4xl font-bold bg-gradient-to-r from-violet-600 to-pink-600 bg-clip-text text-transparent mb-3">150+</div>
// //                   <div className="text-gray-700 font-semibold">Projects Delivered</div>
// //                 </div>
// //                 <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-cyan-50 to-blue-50 border border-cyan-200 hover:shadow-xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2">
// //                   <div className="text-4xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-3">98%</div>
// //                   <div className="text-gray-700 font-semibold">Client Satisfaction</div>
// //                 </div>
// //                 <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-200 hover:shadow-xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2">
// //                   <div className="text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-3">24/7</div>
// //                   <div className="text-gray-700 font-semibold">Premium Support</div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </header>

// //       {/* Content Section */}
 

// //       {/* Services Section Placeholder */}
// //       <section id="services" className="py-20 bg-gradient-to-br from-violet-50 to-indigo-50">
// //         <div className="max-w-7xl mx-auto px-6 text-center">
// //           <h2 className="text-4xl font-bold text-gray-900 mb-8">Our Services</h2>
// //           <p className="text-xl text-gray-600 mb-12">Ready to add your services content here...</p>
// //         </div>
// //       </section>

// //       {/* Clients Section Placeholder */}
// //       <section id="clients" className="py-20 bg-white">
// //         <div className="max-w-7xl mx-auto px-6 text-center">
// //           <h2 className="text-4xl font-bold text-gray-900 mb-8">Our Clients</h2>
// //           <p className="text-xl text-gray-600 mb-12">Client testimonials and logos coming soon...</p>
// //         </div>
// //       </section>

// //       {/* Contact Section Placeholder */}
// //       <section id="contact" className="py-20 bg-gradient-to-br from-indigo-50 to-purple-50">
// //         <div className="max-w-7xl mx-auto px-6 text-center">
// //           <h2 className="text-4xl font-bold text-gray-900 mb-8">Contact Us</h2>
// //           <p className="text-xl text-gray-600 mb-12">Get in touch section coming next...</p>
// //         </div>
// //       </section>

// //       {/* Footer Placeholder */}
// //       <footer className="bg-gray-900 text-white py-12">
// //         <div className="max-w-7xl mx-auto px-6 text-center">
// //           <p className="text-gray-400">Footer content coming soon...</p>
// //         </div>
// //       </footer>
// //     </div>
// //   );
// // };

// // export default PremiumWebsite;

// //version 2

// // import React, { useState, useEffect } from 'react';
// // import { ChevronLeft, ChevronRight, Menu, X } from 'lucide-react';
// // import SEOServiceSection from './SeoSection';
// // import MetaMarketingSection from './MetaSection';
// // import GoogleAdsSection from './googleAds';
// // import greenleavesLogo from './ClientLogos/greenleavesLogo.png';
// // import ConstructionLogo from './ClientLogos/Construction_InsideLogo.png';
// // import HyderabadPropertyLogo from './ClientLogos/HyderabadPropertyLogo.png';
// // import KanactfyLogo from './ClientLogos/kanactifyLogo.jpeg';
// // import DesignVideoSection from './GraphicDesign';
// // import WebsiteAppSection from './WebsiteAndApp';
// // import PremiumFooter from './footer';
// // import ContactSection from './contact';

// // import IdealKitchenLogo from './ClientLogos/IdealKitchenLogo.png';
// // import nihirarealtorsLogo from './ClientLogos/nihirarealtorsLogo.png';
// // import oldCityFoodTruckLogo from './ClientLogos/oldCityFoodTruckLogo.png';
// // import OrionLogo from './ClientLogos/OrionLogo.png';
// // import raoTravelsLogo from './ClientLogos/raoTravelsLogo.png';
// // import vedamsaLogo from './ClientLogos/vedamsaLogo.png';
// // import redYardsLogo from './ClientLogos/redYardsLogo.png'
// // import constructionLogo2 from './ClientLogos/constructionLogo.png';
// // import jj from './ClientLogos/JJ.png';
// // import AmistaLogo from './ClientLogos/Amista logo.png';
// // import siaLogo from './ClientLogos/SIA CLINICS.png';
// // import mebelLogo from './ClientLogos/Meble-Logo (1).png';
// // import sattvaLogo from './ClientLogos/Sattva-Logo-1.png';
// // import shreesuvidhaLogo from './ClientLogos/Shree Suvidha logo.png';
// // import carnivalLogo from './ClientLogos/Carnival Castle.png';
// // import kalyani from './ClientLogos/kalyani.jpeg';


// // import Chatbot from './chatbot';
// // import NavigationIndicators from './NavIndiacator';



// // const PremiumWebsite = () => {
// //   const [currentSlide, setCurrentSlide] = useState(0);
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [currentClientSlide, setCurrentClientSlide] = useState(0);
// //   // const [clientsPerView, setClientsPerView] = useState(getClientsPerView());


// // // Add this clients data array
// // const clients = [
// //   { name: "Green Leaves", logo: greenleavesLogo, category: "" },
// //   { name: "Construction Insides", logo: constructionLogo2, category: "" },
// //   { name: "Hyderabad Property", logo: HyderabadPropertyLogo, category: "" },
// //   { name: "Ideal Kitchen", logo: IdealKitchenLogo, category: "" },
// //   { name: "Nihira Realtors", logo: nihirarealtorsLogo, category: "" },
// //   { name: "Old City Food Truck", logo: oldCityFoodTruckLogo, category: "" },
// //   { name: "Orion", logo: OrionLogo, category: "" },
// //   { name: "Rao Travels", logo: raoTravelsLogo, category: "" },
// //   { name: "Vedamsa", logo: vedamsaLogo, category: "" },
// //   { name: "Red Yards", logo: redYardsLogo, category: "" },
// //   {name : "JJ", logo: jj, category: ""},
// //   {name : "Amista", logo: AmistaLogo, category: ""},
// //   {name : "SIA Clinics", logo: siaLogo, category: ""},
// //   {name : "Meble", logo: mebelLogo, category: ""},
// //   {name : "Sattva", logo: sattvaLogo, category: ""},
// //   {name : "Shree Suvidha", logo: shreesuvidhaLogo, category: ""},
// //   {name : "Carnival Castle", logo: carnivalLogo, category: ""},
// //   {name:"Kalyani Constructions", logo:kalyani, category:""}
  
// // ];

// //   // Sample portfolio images - replace with your actual work
// //   const portfolioItems = [
// //     {
// //       id: 1,
// //       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop",
// //       title: "E-commerce Platform",
// //       category: "Web Development"
// //     },
// //     {
// //       id: 2,
// //       image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=800&h=500&fit=crop",
// //       title: "Mobile  App",
// //       category: "Mobile Development"
// //     },
// //     {
// //       id: 3,
      
// //       image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=500&fit=crop",
// //       title: "Brand Identity Design",
// //       category: "Branding"
// //     },
// //     {
// //       id: 4,
// //       image: "https://images.unsplash.com/photo-1665799871677-f1fd17338b43?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZmFjZWJvb2slMjBhZHN8ZW58MHx8MHx8fDA%3D",
// //       title: "Social Media Marketing",
// //       category: "Meta Ads and google Ads"
// //     },
// //     {
// //       id: 5,
// //       image: " https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=500&fit=crop",
// //       title: "Graphics Design",
// //       category: "Visual Design & Branding"
// //     }
// //   ];


// //   // Add this useEffect for auto-scrolling clients
// // useEffect(() => {
// //   const timer = setInterval(() => {
// //     setCurrentClientSlide((prev) => (prev + 1) % Math.ceil(clients.length / getClientsPerView()));
// //   }, 3000);
// //   return () => clearInterval(timer);
// // }, [clients.length]);

// // // Add this helper function
// // // const getClientsPerView = () => {
// // //   if (typeof window !== 'undefined') {
// // //     if (window.innerWidth < 640) return 2; // mobile
// // //     if (window.innerWidth < 1024) return 4; // tablet
// // //     return 5; // desktop
// // //   }
// // //   return 6;
// // // };
// // const getClientsPerView = () => {
// //   if (window.innerWidth < 640) return 2;        // mobile
// //   if (window.innerWidth < 1024) return 3;       // tablet
// //   return 5;                                     // desktop
// // };

// // useEffect(() => {
// //   const handleResize = () => setClientsPerView(getClientsPerView());
// //   window.addEventListener("resize", handleResize);
// //   handleResize();
// //   return () => window.removeEventListener("resize", handleResize);
// // }, []);

// //   const [clientsPerView, setClientsPerView] = useState(getClientsPerView());


// // // Add these navigation functions
// // const nextClientSlide = () => {
// //   setCurrentClientSlide((prev) => (prev + 1) % Math.ceil(clients.length / getClientsPerView()));
// // };

// // const prevClientSlide = () => {
// //   setCurrentClientSlide((prev) => (prev - 1 + Math.ceil(clients.length / getClientsPerView())) % Math.ceil(clients.length / getClientsPerView()));
// // };

// //   // Auto-slide functionality
// //   useEffect(() => {
// //     const timer = setInterval(() => {
// //       setCurrentSlide((prev) => (prev + 1) % portfolioItems.length);
// //     }, 4000);

// //     return () => clearInterval(timer);
// //   }, [portfolioItems.length]);

// //   const nextSlide = () => {
// //     setCurrentSlide((prev) => (prev + 1) % portfolioItems.length);
// //   };

// //   const prevSlide = () => {
// //     setCurrentSlide((prev) => (prev - 1 + portfolioItems.length) % portfolioItems.length);
// //   };

// //   return (
// //     <div className="min-h-screen bg-white">
// //       <NavigationIndicators/>
// //       <Chatbot/>
// //       {/* Enhanced Header with White Background - Combined Navigation & Works */}
// //      <header className="relative min-h-screen bg-white overflow-hidden">
// //   {/* Animated Background Elements */}
// //   <div className="absolute inset-0">
// //     {/* Large Floating Orbs */}
// //     <div className="absolute top-10 left-10 w-48 sm:w-96 h-48 sm:h-96 bg-gradient-to-r from-pink-200 to-violet-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse"></div>
// //     <div className="absolute top-20 right-20 w-40 sm:w-80 h-40 sm:h-80 bg-gradient-to-r from-cyan-200 to-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" style={{ animationDelay: '1s' }}></div>
// //     <div className="absolute bottom-20 left-1/3 w-36 sm:w-72 h-36 sm:h-72 bg-gradient-to-r from-orange-200 to-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" style={{ animationDelay: '2s' }}></div>
// //     <div className="absolute bottom-40 right-10 w-32 sm:w-64 h-32 sm:h-64 bg-gradient-to-r from-emerald-200 to-teal-200 rounded-full mix-blend-multiply filter blur-3xl opacity-60 animate-pulse" style={{ animationDelay: '3s' }}></div>

// //     {/* Floating Geometric Shapes */}
// //     <div className="absolute top-32 left-1/4 w-4 sm:w-8 h-4 sm:h-8 bg-gradient-to-r from-yellow-400 to-orange-400 rounded-full animate-bounce opacity-40" style={{ animationDelay: '0.5s' }}></div>
// //     <div className="absolute top-1/3 right-1/4 w-3 sm:w-6 h-3 sm:h-6 bg-gradient-to-r from-pink-400 to-red-400 transform rotate-45 animate-spin opacity-40" style={{ animationDuration: '6s' }}></div>
// //     <div className="absolute bottom-1/3 left-1/2 w-2 sm:w-4 h-2 sm:h-4 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full animate-ping opacity-40" style={{ animationDelay: '1.5s' }}></div>
// //     <div className="absolute top-2/3 left-1/3 w-5 sm:w-10 h-5 sm:h-10 bg-gradient-to-r from-blue-400 to-indigo-400 transform rotate-12 animate-bounce opacity-40" style={{ animationDelay: '2.5s' }}></div>

// //     {/* Grid Pattern Overlay */}
// //     <div className="absolute inset-0 opacity-5" style={{
// //       backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Cpath d='M0 0h20v20H0zM20 20h20v20H20z'/%3E%3C/g%3E%3C/svg%3E")`
// //     }}></div>
// //   </div>

// //   {/* Navigation Bar - Removed fixed positioning */}
// //   <nav className="relative z-50 bg-white/95 backdrop-blur-xl border-b border-gray-200 shadow-lg">
// //     <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
// //       {/* Top Row - Logo and Navigation */}
// //       <div className="flex items-center justify-between mb-3 sm:mb-4">
// //         {/* Logo */}
// //         <div className="relative group cursor-pointer">
// //           {/* Animated Background Glow */}
// //           <div className="absolute -inset-1 bg-gradient-to-r from-violet-500 via-purple-500 to-indigo-500 rounded-full blur-md opacity-70 group-hover:opacity-100 animate-gradient-rotate transition-all duration-500"></div>
          
// //           {/* Main Logo Container */}
// //           <div className="relative w-12 sm:w-16 h-12 sm:h-16 bg-gradient-to-br from-white via-violet-50 to-indigo-50 rounded-full flex items-center justify-center shadow-2xl border border-white/50 backdrop-blur-lg overflow-hidden transform transition-all duration-500 group-hover:scale-110 group-hover:rotate-6 animate-float">
            
// //             {/* Floating Particles */}
// //             <div className="absolute top-1 left-2 sm:left-3 w-1 h-1 bg-violet-400 rounded-full animate-particle-1 opacity-60"></div>
// //             <div className="absolute top-2 sm:top-3 right-1 w-0.5 h-0.5 bg-indigo-400 rounded-full animate-particle-2 opacity-60"></div>
// //             <div className="absolute bottom-2 sm:bottom-3 left-1 w-0.5 h-0.5 bg-purple-400 rounded-full animate-particle-3 opacity-60"></div>
            
// //             {/* Shimmer Effect */}
// //             <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -skew-x-12 animate-shimmer rounded-full"></div>
            
// //             {/* Logo Image - Full Container */}
// //             <img
// //               src={KanactfyLogo} 
// //               alt="Konnectify Logo"
// //               className="w-full h-full object-cover rounded-full relative z-10 transition-all duration-300 group-hover:scale-105 filter drop-shadow-lg p-0"
// //             />
            
// //             {/* Pulse Ring */}
// //             <div className="absolute inset-0 rounded-full border-2 border-violet-400/30 animate-pulse-ring"></div>
// //           </div>
// //         </div>

// //         {/* Company Name - Hidden on small mobile */}
// //         <div className="hidden xs:block">
// //           <span className="text-xl sm:text-3xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 bg-clip-text text-transparent">
           
// //           </span>
// //         </div>

// //         {/* Desktop Navigation */}
// //         <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
// //           <a href="#home" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //             Home
// //           </a>
// //           <a href="#services" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //             Services
// //           </a>
// //           <a href="#clients" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //             Clients
// //           </a>
// //           <a href="#contact" className="text-gray-700 hover:text-violet-600 font-medium transition-all duration-300 hover:scale-110">
// //             Contact
// //           </a>
// //           {/* <button className="bg-gradient-to-r from-violet-500 to-indigo-500 text-white px-6 lg:px-8 py-2 lg:py-3 rounded-full hover:shadow-2xl transform hover:scale-105 transition-all duration-300 shadow-lg text-sm lg:text-base">
// //             Get Started
// //           </button> */}
// //           <button 
// //   onClick={() => {
// //     document.getElementById('contact')?.scrollIntoView({ 
// //       behavior: 'smooth',
// //       block: 'start'
// //     });
// //   }}
// //   className="bg-gradient-to-r from-violet-500 to-indigo-500 text-white px-6 lg:px-8 py-2 lg:py-3 rounded-full hover:shadow-2xl transform hover:scale-105 transition-all duration-300 shadow-lg text-sm lg:text-base"
// // >
// //   Get Started
// // </button>
// //         </div>

// //         {/* Mobile Menu Button */}
// //         <button 
// //           className="md:hidden text-gray-700 p-2"
// //           onClick={() => setIsMenuOpen(!isMenuOpen)}
// //         >
// //           {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
// //         </button>
// //       </div>

// //       {/* Auto-Scrolling Clients Slider */}
// //       <div className="relative">
// //         <div className="flex items-center justify-between mb-2 sm:mb-3">
// //           <h2 className="text-sm sm:text-xl font-bold bg-gradient-to-r from-violet-600 to-indigo-600 bg-clip-text text-transparent">
// //             Trusted Clients
// //           </h2>
// //           <div className="flex space-x-1 sm:space-x-2">
// //             <button 
// //               onClick={prevClientSlide}
// //               className="w-6 sm:w-8 h-6 sm:h-8 bg-violet-100 hover:bg-violet-200 text-violet-600 rounded-full flex items-center justify-center transition-all"
// //             >
// //               <ChevronLeft size={12} className="sm:w-4 sm:h-4" />
// //             </button>
// //             <button 
// //               onClick={nextClientSlide}
// //               className="w-6 sm:w-8 h-6 sm:h-8 bg-violet-100 hover:bg-violet-200 text-violet-600 rounded-full flex items-center justify-center transition-all"
// //             >
// //               <ChevronRight size={12} className="sm:w-4 sm:h-4" />
// //             </button>
// //           </div>
// //         </div>

// //         {/* Auto-Scrolling Clients Display */}
// //         {/* <div className="overflow-hidden">
// //           <div 
// //             className="flex transition-transform duration-500 ease-in-out"
// //             style={{
// //               transform: `translateX(-${currentClientSlide * 100}%)`
// //             }}
// //           >
// // {Array.from({ length: Math.ceil(clients.length / 5) }).map((_, slideIndex) => (
// //   <div key={slideIndex} className="flex w-full justify-between flex-shrink-0 space-x-4">
// //     {clients
// //       .slice(slideIndex * 5, (slideIndex + 1) * 5)
// //       .map((client) => (
// //         <div
// //           key={client.name}
// //           className="group bg-white/90 backdrop-blur-sm p-4 rounded-xl border border-gray-200 hover:border-violet-300 shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer flex-1 max-w-[20%]"
// //         >
// //           <div className="flex flex-col items-center text-center">
// //             <div className="w-32 sm:w-48 h-32 sm:h-48 mb-4 bg-white rounded-2xl shadow-2xl ring-1 ring-violet-200 flex items-center justify-center p-4 group-hover:shadow-violet-300 transition-all duration-300 border border-gray-100">
// //               <img
// //                 src={client.logo}
// //                 alt={`${client.name} logo`}
// //                 className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
// //                 onError={(e) => {
// //                   e.target.style.display = 'none';
// //                   e.target.nextSibling.style.display = 'flex';
// //                 }}
// //               />
// //               <div
// //                 className="w-full h-full bg-gradient-to-br from-violet-500 via-purple-500 to-indigo-600 rounded-xl flex items-center justify-center text-white font-bold text-2xl sm:text-4xl shadow-md"
// //                 style={{ display: 'none' }}
// //               >
// //                 {client.name.split(' ').map(word => word[0]).join('')}
// //               </div>
// //             </div>
// //             <h4 className="text-sm font-semibold text-gray-900 mb-1 truncate w-full group-hover:text-violet-600 transition-colors">
// //               {client.name}
// //             </h4>
// //             <p className="text-xs text-gray-500 truncate w-full">
// //               {client.category}
// //             </p>
// //           </div>
// //         </div>
// //       ))}
// //   </div>
// // ))}

// //           </div>
// //         </div> */}
// //         <div className="overflow-hidden">
// //   <div 
// //     className="flex transition-transform duration-500 ease-in-out"
// //     style={{
// //       transform: `translateX(-${currentClientSlide * 100}%)`
// //     }}
// //   >
// //     {Array.from({ length: Math.ceil(clients.length / clientsPerView) }).map((_, slideIndex) => (
// //       <div key={slideIndex} className="flex w-full flex-shrink-0 justify-center gap-4">
// //         {clients
// //           .slice(slideIndex * clientsPerView, (slideIndex + 1) * clientsPerView)
// //           .map((client) => (
// //             <div
// //               key={client.name}
// //               className="group bg-white/90 backdrop-blur-sm p-4 rounded-xl border border-gray-200 hover:border-violet-300 shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer flex-1 max-w-[48%] sm:max-w-[31%] lg:max-w-[19%]"
// //             >
// //               <div className="flex flex-col items-center text-center">
// //                 <div className="w-32 sm:w-44 lg:w-48 h-32 sm:h-44 lg:h-48 mb-4 bg-white rounded-2xl shadow-2xl ring-1 ring-violet-200 flex items-center justify-center p-4 group-hover:shadow-violet-300 transition-all duration-300 border border-gray-100">
// //                   <img
// //                     src={client.logo}
// //                     alt={`${client.name} logo`}
// //                     className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
// //                     onError={(e) => {
// //                       e.target.style.display = 'none';
// //                       e.target.nextSibling.style.display = 'flex';
// //                     }}
// //                   />
// //                   <div
// //                     className="w-full h-full bg-gradient-to-br from-violet-500 via-purple-500 to-indigo-600 rounded-xl flex items-center justify-center text-white font-bold text-2xl sm:text-3xl lg:text-4xl shadow-md"
// //                     style={{ display: 'none' }}
// //                   >
// //                     {client.name.split(' ').map(word => word[0]).join('')}
// //                   </div>
// //                 </div>
// //                 <h4 className="text-sm font-semibold text-gray-900 mb-1 truncate w-full group-hover:text-violet-600 transition-colors">
// //                   {client.name}
// //                 </h4>
// //                 <p className="text-xs text-gray-500 truncate w-full">
// //                   {client.category}
// //                 </p>
// //               </div>
// //             </div>
// //           ))}
// //       </div>
// //     ))}
// //   </div>
// // </div>


    
// //         {/* Desktop pagination dots */}
// // <div className="hidden sm:flex justify-center space-x-2 mt-3">
// //   {Array.from({ length: Math.ceil(clients.length / getClientsPerView()) }).map((_, index) => (
// //     <button
// //       key={index}
// //       onClick={() => setCurrentClientSlide(index)}
// //       className={`w-2 h-2 rounded-full transition-all ${
// //         index === currentClientSlide 
// //           ? 'bg-violet-500' 
// //           : 'bg-gray-300 hover:bg-gray-400'
// //       }`}
// //     />
// //   ))}
// // </div>

// // {/* Mobile pagination dots */}

// //       </div>

// //       {/* Mobile Navigation */}
// //       {isMenuOpen && (
// //         <div className="md:hidden mt-4 sm:mt-6 pb-4 sm:pb-6 border-t border-gray-200">
// //           <nav className="flex flex-col space-y-3 sm:space-y-4 pt-4 sm:pt-6">
// //             <a href="#home" className="text-gray-700 hover:text-violet-600 font-medium">Home</a>
// //             <a href="#services" className="text-gray-700 hover:text-violet-600 font-medium">Services</a>
// //             <a href="#clients" className="text-gray-700 hover:text-violet-600 font-medium">Clients</a>
// //             <a href="#contact" className="text-gray-700 hover:text-violet-600 font-medium">Contact</a>
// //             {/* <button className="bg-gradient-to-r from-violet-500 to-indigo-500 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full w-fit shadow-lg text-sm sm:text-base">
// //               Get Started
// //             </button> */}
// //              <button 
// //   onClick={() => {
// //     document.getElementById('contact')?.scrollIntoView({ 
// //       behavior: 'smooth',
// //       block: 'start'
// //     });
// //   }}
// //   className="bg-gradient-to-r from-violet-500 to-indigo-500 text-white px-6 lg:px-8 py-2 lg:py-3 rounded-full hover:shadow-2xl transform hover:scale-105 transition-all duration-300 shadow-lg text-sm lg:text-base"
// // >
// //   Get Started
// // </button>
// //           </nav>
// //         </div>
// //       )}
// //     </div>
// //   </nav>

// //   {/* Main Content Container */}
// //   <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 lg:pt-16 pb-8 sm:pb-16">
// //     {/* Main Content based on Current Slide */}
// //     <div className="text-center mb-8 sm:mb-12 lg:mb-16">
// //       <div className="inline-flex items-center px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4 bg-gradient-to-r from-violet-50 to-indigo-50 border border-violet-200 rounded-full mb-6 sm:mb-8 lg:mb-10 shadow-xl animate-pulse">
// //         <span className="text-violet-700 text-xs sm:text-sm lg:text-base font-semibold">✨ Branding Irreversible ✨</span>
// //       </div>
      
// //       <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-4 sm:mb-6 lg:mb-8 px-4">
// //         <span className="block text-gray-900 mb-2 sm:mb-3 lg:mb-4">Featured Project:</span>
// //         <span className="block bg-gradient-to-r from-violet-600 via-pink-600 to-cyan-600 bg-clip-text text-transparent animate-pulse">
// //           {portfolioItems[currentSlide].title}
// //         </span>
// //       </h1>
      
// //       <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-6 sm:mb-8 lg:mb-12 px-4 sm:px-6">
// //         {portfolioItems[currentSlide].category} - Innovative design meets cutting-edge technology to deliver exceptional user experiences with modern aesthetics and functionality
// //       </p>
// //     </div>

// //     {/* Large Featured Work Display */}
// //     <div className="relative max-w-5xl mx-auto">
// //       <div className="relative h-[200px] sm:h-[300px] md:h-[400px] lg:h-[500px] rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl bg-white border border-gray-200 transform hover:scale-105 transition-all duration-700">
// //         <img 
// //           src={portfolioItems[currentSlide].image} 
// //           alt={portfolioItems[currentSlide].title}
// //           className="w-full h-full object-cover transition-all duration-700"
// //         />
        
// //         {/* Content Overlay */}
// //         <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
// //         <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-4 md:p-6 lg:p-8">
// //           <div className="flex items-end justify-between">
// //             <div className="flex-1">
// //               <div className="inline-flex items-center px-2 sm:px-3 lg:px-4 py-1 sm:py-1.5 lg:py-2 bg-gradient-to-r from-violet-500 to-pink-500 text-white text-xs sm:text-sm font-bold rounded-full mb-2 sm:mb-3 lg:mb-4 shadow-lg">
// //                 {portfolioItems[currentSlide].category}
// //               </div>
// //               <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-white mb-1 sm:mb-2 lg:mb-3">{portfolioItems[currentSlide].title}</h3>
// //               <p className="text-white/90 text-xs sm:text-sm md:text-base lg:text-lg max-w-2xl leading-relaxed mb-3 sm:mb-4 lg:mb-6 hidden sm:block">
// //                 Exceptional user experience designed with modern technologies and innovative approaches to solve real business challenges.
// //               </p>
             
// //             </div>
            
// //             <div className="hidden lg:block text-right ml-4">
// //               <div className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white/30">
// //                 {String(currentSlide + 1).padStart(2, '0')}
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Call to Action */}
// //       <div className="text-center mt-8 sm:mt-12 lg:mt-16">
// //         <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 lg:gap-6 justify-center items-center mb-8 sm:mb-10 lg:mb-12">
// //           <button className="bg-gradient-to-r from-violet-500 via-purple-500 to-pink-500 text-white px-8 sm:px-12 lg:px-16 py-3 sm:py-3.5 lg:py-4 rounded-full font-bold text-sm sm:text-base lg:text-lg hover:shadow-2xl transform hover:scale-110 hover:-translate-y-2 transition-all duration-300 shadow-xl w-full sm:w-auto">
// //             Start Your Project
// //           </button>
// //           {/* <button className="bg-gradient-to-r from-gray-50 to-gray-100 border-2 border-gray-200 text-gray-700 px-8 sm:px-12 lg:px-16 py-3 sm:py-3.5 lg:py-4 rounded-full font-bold text-sm sm:text-base lg:text-lg hover:shadow-xl hover:border-gray-300 transition-all duration-300 transform hover:scale-110 hover:-translate-y-2 w-full sm:w-auto">
// //             View All Works
// //           </button> */}
// //           <button 
// //   onClick={() => {
// //     window.open('https://www.instagram.com/kanactify?igsh=MTcydGt2bDhuN2RkeQ%3D%3D&utm_source=qr', '_blank');
// //   }}
// //   className="bg-gradient-to-r from-gray-50 to-gray-100 border-2 border-gray-200 text-gray-700 px-8 sm:px-12 lg:px-16 py-3 sm:py-3.5 lg:py-4 rounded-full font-bold text-sm sm:text-base lg:text-lg hover:shadow-xl hover:border-gray-300 transition-all duration-300 transform hover:scale-110 hover:-translate-y-2 w-full sm:w-auto"
// // >
// //   View All Works
// // </button>
// //         </div>
        
// //         {/* Stats Cards */}
// //         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 pt-6 sm:pt-8 lg:pt-12">
// //           <div className="text-center p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-violet-50 to-indigo-50 border border-violet-200 hover:shadow-xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2">
// //             <div className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-violet-600 to-pink-600 bg-clip-text text-transparent mb-1 sm:mb-2 lg:mb-3">150+</div>
// //             <div className="text-gray-700 font-semibold text-xs sm:text-sm lg:text-base">Projects Delivered</div>
// //           </div>
// //           <div className="text-center p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-cyan-50 to-blue-50 border border-cyan-200 hover:shadow-xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2">
// //             <div className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-1 sm:mb-2 lg:mb-3">98%</div>
// //             <div className="text-gray-700 font-semibold text-xs sm:text-sm lg:text-base">Client Satisfaction</div>
// //           </div>
// //           <div className="text-center p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-200 hover:shadow-xl transition-all duration-500 transform hover:scale-105 hover:-translate-y-2">
// //             <div className="text-2xl sm:text-3xl lg:text-4xl font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent mb-1 sm:mb-2 lg:mb-3">24/7</div>
// //             <div className="text-gray-700 font-semibold text-xs sm:text-sm lg:text-base">Premium Support</div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   </div>

// //   <style jsx>{`
// //     @keyframes gradient-rotate {
// //       0% { transform: rotate(0deg) scale(1); }
// //       25% { transform: rotate(90deg) scale(1.05); }
// //       50% { transform: rotate(180deg) scale(1); }
// //       75% { transform: rotate(270deg) scale(1.05); }
// //       100% { transform: rotate(360deg) scale(1); }
// //     }
    
// //     @keyframes float {
// //       0%, 100% { transform: translateY(0px) rotate(0deg); }
// //       50% { transform: translateY(-8px) rotate(2deg); }
// //     }
    
// //     @keyframes shimmer {
// //       0% { transform: translateX(-100%) skewX(-12deg); }
// //       100% { transform: translateX(200%) skewX(-12deg); }
// //     }
    
// //     @keyframes particle-1 {
// //       0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.6; }
// //       25% { transform: translate(10px, -5px) scale(1.2); opacity: 1; }
// //       50% { transform: translate(-5px, -10px) scale(0.8); opacity: 0.4; }
// //       75% { transform: translate(8px, 5px) scale(1.1); opacity: 0.8; }
// //     }
    
// //     @keyframes particle-2 {
// //       0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.6; }
// //       33% { transform: translate(-8px, 10px) scale(1.3); opacity: 1; }
// //       66% { transform: translate(12px, -8px) scale(0.7); opacity: 0.3; }
// //     }
    
// //     @keyframes particle-3 {
// //       0%, 100% { transform: translate(0, 0) scale(1); opacity: 0.6; }
// //       40% { transform: translate(6px, -12px) scale(1.1); opacity: 0.9; }
// //       80% { transform: translate(-10px, 6px) scale(0.9); opacity: 0.5; }
// //     }
    
// //     @keyframes pulse-ring {
// //       0% { transform: scale(1); opacity: 0.8; }
// //       50% { transform: scale(1.1); opacity: 0.3; }
// //       100% { transform: scale(1.2); opacity: 0; }
// //     }
    
// //     .animate-gradient-rotate { animation: gradient-rotate 8s linear infinite; }
// //     .animate-float { animation: float 6s ease-in-out infinite; }
// //     .animate-shimmer { animation: shimmer 3s ease-in-out infinite; }
// //     .animate-particle-1 { animation: particle-1 4s ease-in-out infinite; }
// //     .animate-particle-2 { animation: particle-2 5s ease-in-out infinite; }
// //     .animate-particle-3 { animation: particle-3 6s ease-in-out infinite; }
// //     .animate-pulse-ring { animation: pulse-ring 2s ease-out infinite; }
    
// //     /* Responsive breakpoints */
// //     @media (min-width: 475px) {
// //       .xs\\:block { display: block; }
// //     }
// //   `}</style>
// // </header>

// //       {/* Content Section */}
   

// //       {/* Services Section Placeholder */}
// //       <section id="services" className="py-20 bg-gradient-to-br from-violet-50 to-indigo-50">
// //         <div className="max-w-7xl mx-auto px-6 text-center">
// //           <h2 className="text-4xl font-bold text-gray-900 mb-8">Our Services</h2>
// //       <SEOServiceSection/>
// //       <MetaMarketingSection/>
// //       <GoogleAdsSection/>
// //       <DesignVideoSection/>
// //       <WebsiteAppSection/>
// //         </div>
// //       </section>
// // {/* Clients Section */}
// // <section id="clients" className="py-24 bg-gradient-to-br from-violet-50 via-indigo-50 to-purple-50 relative overflow-hidden">
// //   {/* Enhanced Background Elements */}
// //   <div className="absolute inset-0">
// //     <div className="absolute top-20 left-20 w-80 h-80 bg-gradient-to-r from-violet-200 to-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse"></div>
// //     <div className="absolute bottom-20 right-20 w-96 h-96 bg-gradient-to-r from-indigo-200 to-cyan-200 rounded-full mix-blend-multiply filter blur-3xl opacity-40 animate-pulse" style={{ animationDelay: '2s' }}></div>
// //     <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-purple-200 to-pink-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '4s' }}></div>
// //   </div>

// //   <div className="relative z-10 max-w-7xl mx-auto px-6">
// //     <div className="text-center mb-20">
// //       <div className="inline-flex items-center px-8 py-4 bg-white/90 backdrop-blur-md border border-violet-200 rounded-full mb-10 shadow-xl">
// //         <span className="text-violet-700 text-lg font-semibold tracking-wide">🤝 Trusted by Industry Leaders</span>
// //       </div>
      
// //       <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-8 leading-tight">
// //         Our Amazing
// //         <span className="block bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent mt-2">
// //           Clients
// //         </span>
// //       </h2>
// //       <p className="text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed font-light">
// //         We're proud to work with forward-thinking companies who trust us to bring their digital visions to life
// //       </p>
// //     </div>

// //     {/* Premium Client Logos Grid */}
// //     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-10 mb-20">
// //       {[
// //         { name: "Green Leaves", logoFile: greenleavesLogo },
// //         { name: "Construction Insides", logoFile: constructionLogo2 },
// //         { name: "Hyderabad Property", logoFile: HyderabadPropertyLogo },
// //         { name: "Ideal Kitchen", logoFile: IdealKitchenLogo },
// //         { name: "Nihira Realtors", logoFile: nihirarealtorsLogo },
// //         { name: "Old City Food Truck", logoFile: oldCityFoodTruckLogo },
// //         { name: "Orion", logoFile: OrionLogo },
// //         { name: "Rao Travels", logoFile: raoTravelsLogo},
// //         { name: "Vedamsa", logoFile: vedamsaLogo },
// //         { name: "Red Yards", logoFile: redYardsLogo },
// //         {name:"Amista",logoFile: AmistaLogo},
// //         {name:"jj Wellness clinic",logoFile:jj},
// //         {name:"Meble",logoFile:mebelLogo},
// //         {name:"Sattva", logoFile:sattvaLogo},
// //         {name:"SIA Clinics",logoFile:siaLogo},
// //         {name:"Carnival Castle",logoFile:carnivalLogo},
// //         {name:"Shree Suvidha",logoFile:shreesuvidhaLogo},
// //         {name:"Kalyani Constructions",logoFile:kalyani},

// //       ].map((client, index) => (
// //         <div 
// //           key={index}
// //           className="group bg-white/95 backdrop-blur-lg p-8 rounded-3xl border border-white/60 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:scale-110 hover:-translate-y-4 cursor-pointer"
// //           style={{ 
// //             animation: `slideInUp 0.8s ease-out ${index * 0.15}s both`,
// //             backdropFilter: 'blur(20px)'
// //           }}
// //         >
// //           {/* Logo Container */}
// //           <div className="w-40 h-40 mx-auto mb-6 bg-white rounded-3xl shadow-lg flex items-center justify-center p-2 group-hover:shadow-xl transition-all duration-300 border border-gray-100">
// //             <img 
// //               src={client.logoFile}
// //               alt={`${client.name} logo`}
// //               className="w-36 h-36 object-contain filter group-hover:scale-105 transition-transform duration-300"
// //               style={{
// //                 maxWidth: '144px',
// //                 maxHeight: '144px',
// //                 objectFit: 'contain'
// //               }}
// //               onError={(e) => {
// //                 // Premium fallback with company initials
// //                 e.target.style.display = 'none';
// //                 e.target.nextSibling.style.display = 'flex';
// //               }}
// //             />
// //             <div 
// //               className="w-36 h-36 bg-gradient-to-br from-violet-500 via-purple-500 to-indigo-500 rounded-2xl flex items-center justify-center text-white font-bold text-4xl shadow-lg"
// //               style={{ display: 'none' }}
// //             >
// //               {client.name.split(' ').map(word => word[0]).join('')}
// //             </div>
// //           </div>
          
// //           {/* Company Name */}
// //           <h3 className="text-center text-gray-800 font-bold text-lg mb-2 group-hover:text-violet-600 transition-colors duration-300">
// //             {client.name}
// //           </h3>
          
// //           {/* Decorative Line */}
// //           <div className="w-12 h-1 bg-gradient-to-r from-violet-400 to-indigo-400 rounded-full mx-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
// //         </div>
// //       ))}
// //     </div>

// //     {/* Trust Indicators */}
// //     <div className="text-center">
// //       <div className="inline-flex items-center space-x-8 bg-white/90 backdrop-blur-md px-12 py-6 rounded-2xl shadow-xl border border-white/50">
// //         <div className="text-center">
// //           <div className="text-3xl font-bold text-violet-600 mb-1">50+</div>
// //           <div className="text-sm text-gray-600 font-medium">Happy Clients</div>
// //         </div>
// //         <div className="w-px h-12 bg-gray-300"></div>
// //         <div className="text-center">
// //           <div className="text-3xl font-bold text-indigo-600 mb-1">100%</div>
// //           <div className="text-sm text-gray-600 font-medium">Satisfaction</div>
// //         </div>
// //         <div className="w-px h-12 bg-gray-300"></div>
// //         <div className="text-center">
// //           <div className="text-3xl font-bold text-purple-600 mb-1">24/7</div>
// //           <div className="text-sm text-gray-600 font-medium">Support</div>
// //         </div>
// //       </div>
// //     </div>
// //   </div>
// // </section>

// // <style jsx>{`
// //   @keyframes slideInUp {
// //     from {
// //       opacity: 0;
// //       transform: translateY(60px) scale(0.9);
// //     }
// //     to {
// //       opacity: 1;
// //       transform: translateY(0) scale(1);
// //     }
// //   }
  
// //   @keyframes float {
// //     0%, 100% {
// //       transform: translateY(0px);
// //     }
// //     50% {
// //       transform: translateY(-10px);
// //     }
// //   }
  
// //   .group:hover {
// //     animation: float 3s ease-in-out infinite;
// //   }
  
// //   /* Enhanced responsive design */
// //   @media (max-width: 768px) {
// //     .grid {
// //       grid-template-columns: repeat(2, 1fr);
// //       gap: 1.5rem;
// //     }
// //   }
  
// //   @media (max-width: 480px) {
// //     .grid {
// //       grid-template-columns: 1fr;
// //       gap: 1rem;
// //     }
// //   }
// // `}</style>

// //       {/* Contact Section */}
// //      <ContactSection/>
// //       {/* Footer Placeholder */}
// //      <PremiumFooter/>
// //     </div>
// //   );
// // };

// // export default PremiumWebsite;

// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Menu, X, ArrowUpRight } from 'lucide-react';

// import greenleavesLogo from './ClientLogos/greenleavesLogo.png';
// import HyderabadPropertyLogo from './ClientLogos/HyderabadPropertyLogo.png';
// import KanactfyLogo from './ClientLogos/kanactifyLogo.jpeg';
// import IdealKitchenLogo from './ClientLogos/IdealKitchenLogo.png';
// import nihirarealtorsLogo from './ClientLogos/nihirarealtorsLogo.png';
// import oldCityFoodTruckLogo from './ClientLogos/oldCityFoodTruckLogo.png';
// import OrionLogo from './ClientLogos/OrionLogo.png';
// import raoTravelsLogo from './ClientLogos/raoTravelsLogo.png';
// import vedamsaLogo from './ClientLogos/vedamsaLogo.png';
// import redYardsLogo from './ClientLogos/redYardsLogo.png';
// import constructionLogo2 from './ClientLogos/constructionLogo.png';
// import jj from './ClientLogos/JJ.png';
// import AmistaLogo from './ClientLogos/Amista logo.png';
// import siaLogo from './ClientLogos/SIA CLINICS.png';
// import mebelLogo from './ClientLogos/Meble-Logo (1).png';
// import sattvaLogo from './ClientLogos/Sattva-Logo-1.png';
// import shreesuvidhaLogo from './ClientLogos/Shree Suvidha logo.png';
// import carnivalLogo from './ClientLogos/Carnival Castle.png';
// import kalyani from './ClientLogos/kalyani.jpeg';

// import Chatbot from './chatbot';
// import NavigationIndicators from './NavIndiacator';

// /* ═══════════════════════════════════════
//    CSS
// ═══════════════════════════════════════ */
// const G = `
// @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=DM+Sans:wght@300;400;500;600;700&display=swap');

// :root{
//   --r:#E31E24; --r2:#ff4d52; --rg:rgba(227,30,36,0.12);
//   --rt:rgba(227,30,36,0.06); --ink:#0B0B0B; --muted:#6E6E6E;
//   --muted2:#999; --border:#E8E8E8; --surf:#F7F7F7;
//   --white:#FFFFFF; --dark:#0D0D0D;
//   --serif:'Playfair Display',Georgia,serif;
//   --sans:'DM Sans',sans-serif;
//   --spring:cubic-bezier(0.34,1.56,0.64,1);
//   --ease:cubic-bezier(0.4,0,0.2,1);
// }
// *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
// html{scroll-behavior:smooth}
// body{font-family:var(--sans);background:var(--white);color:var(--ink);-webkit-font-smoothing:antialiased;overflow-x:hidden}
// a{text-decoration:none;color:inherit}ul{list-style:none}img{display:block;max-width:100%}

// .rv{opacity:0;transform:translateY(40px);transition:opacity .8s var(--ease),transform .8s var(--ease)}
// .rv.in{opacity:1;transform:none}
// .rv-l{opacity:0;transform:translateX(-48px);transition:opacity .8s var(--ease),transform .8s var(--ease)}
// .rv-l.in{opacity:1;transform:none}
// .rv-r{opacity:0;transform:translateX(48px);transition:opacity .8s var(--ease),transform .8s var(--ease)}
// .rv-r.in{opacity:1;transform:none}
// .d1{transition-delay:.1s}.d2{transition-delay:.2s}.d3{transition-delay:.3s}.d4{transition-delay:.4s}.d5{transition-delay:.5s}

// .gt{background:linear-gradient(135deg,var(--r) 0%,#ff6b35 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
// .ptag{display:inline-flex;align-items:center;gap:7px;background:var(--rt);color:var(--r);border:1px solid rgba(227,30,36,.18);border-radius:100px;padding:6px 16px;font-family:var(--sans);font-size:11px;font-weight:700;letter-spacing:1.8px;text-transform:uppercase}
// .pdot{width:6px;height:6px;background:var(--r);border-radius:50%}

// /* NAV */
// .nav{position:fixed;top:0;left:0;right:0;z-index:500;padding:20px 0;transition:background .35s var(--ease),padding .35s,box-shadow .35s}
// .nav.st{background:rgba(255,255,255,.97);backdrop-filter:blur(24px);padding:13px 0;box-shadow:0 1px 0 var(--border),0 8px 40px rgba(0,0,0,.05)}
// .nw{max-width:1280px;margin:0 auto;padding:0 44px;display:flex;align-items:center;justify-content:space-between}
// .nlogo{display:flex;align-items:center;gap:10px;font-family:var(--sans);font-size:19px;font-weight:800;color:var(--ink);letter-spacing:-.2px}
// .nlogo img{width:36px;height:36px;border-radius:9px;object-fit:cover}
// .nlogo span{color:var(--r)}
// .nlinks{display:flex;align-items:center;gap:34px}
// .nlinks a{font-size:14px;font-weight:600;color:var(--muted);transition:color .2s;position:relative}
// .nlinks a::after{content:'';position:absolute;bottom:-4px;left:0;right:0;height:1.5px;background:var(--r);transform:scaleX(0);transform-origin:right;transition:transform .3s var(--ease)}
// .nlinks a:hover{color:var(--ink)}
// .nlinks a:hover::after{transform:scaleX(1);transform-origin:left}
// .ncta{padding:11px 24px;border-radius:100px;background:var(--r);color:#fff;font-family:var(--sans);font-size:13px;font-weight:700;border:none;cursor:pointer;box-shadow:0 6px 20px var(--rg);transition:transform .25s var(--spring),box-shadow .25s}
// .ncta:hover{transform:translateY(-2px) scale(1.02);box-shadow:0 10px 30px var(--rg)}
// .nbg{display:none;background:none;border:none;cursor:pointer;padding:4px;flex-direction:column;gap:5px}
// .nbg span{width:24px;height:1.5px;background:var(--ink);display:block;border-radius:2px}
// .mobmenu{position:fixed;inset:0;z-index:499;background:rgba(255,255,255,.98);backdrop-filter:blur(20px);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:36px;opacity:0;pointer-events:none;transition:opacity .3s}
// .mobmenu.op{opacity:1;pointer-events:all}
// .mobmenu a{font-family:var(--serif);font-size:40px;color:var(--ink);transition:color .2s}
// .mobmenu a:hover{color:var(--r)}
// .mcx{position:absolute;top:28px;right:36px;background:none;border:none;cursor:pointer}

// /* MARQUEE */
// .mqbar{overflow:hidden;border-top:1px solid var(--border);border-bottom:1px solid var(--border);padding:16px 0;mask:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent);-webkit-mask:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent)}
// .mqinner{display:flex;width:max-content;animation:mq 32s linear infinite}
// .mqitem{display:flex;align-items:center;gap:14px;padding:0 28px;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:var(--muted);white-space:nowrap}
// .mqstar{color:var(--r);font-size:10px}
// @keyframes mq{from{transform:translateX(0)}to{transform:translateX(-50%)}}

// /* HERO */
// .hero{min-height:100vh;display:grid;grid-template-columns:1fr 1fr;align-items:center}
// .hleft{padding:130px 0 80px 44px;max-width:640px}
// .hright{position:relative;height:100vh;overflow:hidden}
// .hright img{width:100%;height:100%;object-fit:cover}
// .hright-ov{position:absolute;inset:0;background:linear-gradient(to right,rgba(255,255,255,1) 0%,rgba(255,255,255,0) 35%)}
// .htag{margin-bottom:28px}
// .htitle{font-family:var(--serif);font-size:clamp(44px,5.5vw,80px);line-height:1.04;color:var(--ink);margin-bottom:24px;font-weight:900}
// .htitle em{font-style:italic;color:var(--r)}
// .hdesc{font-size:17px;color:var(--muted);line-height:1.82;max-width:480px;margin-bottom:44px;font-weight:400}
// .hbtns{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:64px}
// .bp{display:inline-flex;align-items:center;gap:8px;padding:15px 32px;border-radius:100px;background:var(--r);color:#fff;font-family:var(--sans);font-size:14px;font-weight:700;border:none;cursor:pointer;box-shadow:0 8px 24px var(--rg);transition:transform .25s var(--spring),box-shadow .25s}
// .bp:hover{transform:translateY(-3px);box-shadow:0 14px 36px var(--rg)}
// .bg{display:inline-flex;align-items:center;gap:8px;padding:15px 32px;border-radius:100px;background:transparent;color:var(--ink);font-family:var(--sans);font-size:14px;font-weight:600;border:1.5px solid var(--border);cursor:pointer;transition:border-color .2s,color .2s,transform .2s}
// .bg:hover{border-color:var(--r);color:var(--r);transform:translateY(-2px)}
// .hstats{display:flex;gap:0;padding-top:40px;border-top:1px solid var(--border)}
// .hst{flex:1}
// .hst+.hst{padding-left:28px;border-left:1px solid var(--border);margin-left:28px}
// .hstn{font-family:var(--serif);font-size:clamp(26px,3.5vw,42px);line-height:1;color:var(--r);margin-bottom:5px;font-weight:900}
// .hstl{font-size:11px;color:var(--muted);font-weight:600;letter-spacing:.5px;text-transform:uppercase}

// /* SERVICES */
// .svsec{padding:140px 44px;max-width:1280px;margin:0 auto}
// .svhdr{display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:end;margin-bottom:80px}
// .svhdr h2{font-family:var(--serif);font-size:clamp(34px,4.5vw,58px);line-height:1.1;font-weight:900}
// .svhdr p{font-size:16px;color:var(--muted);line-height:1.82}
// .svlm{margin-top:22px;display:inline-flex;align-items:center;gap:7px;font-size:14px;font-weight:700;color:var(--r);cursor:pointer}
// .svlm svg{transition:transform .2s}
// .svlm:hover svg{transform:translate(3px,-3px)}
// .svgrid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
// .svc{position:relative;border:1px solid var(--border);border-radius:24px;padding:44px 36px 42px;background:var(--white);overflow:hidden;transition:border-color .3s,transform .35s var(--spring),box-shadow .35s;cursor:default}
// .svc::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,var(--rt),transparent 65%);opacity:0;transition:opacity .35s}
// .svc:hover{border-color:rgba(227,30,36,.3);transform:translateY(-8px);box-shadow:0 24px 64px rgba(0,0,0,.08)}
// .svc:hover::before{opacity:1}
// .svcn{position:absolute;top:22px;right:26px;font-family:var(--serif);font-size:68px;line-height:1;color:var(--border);pointer-events:none;transition:color .3s}
// .svc:hover .svcn{color:rgba(227,30,36,.06)}
// .svcicon{width:54px;height:54px;background:var(--rt);border-radius:16px;display:flex;align-items:center;justify-content:center;margin-bottom:26px;font-size:24px;transition:background .3s,transform .35s var(--spring)}
// .svc:hover .svcicon{background:var(--r);transform:scale(1.1) rotate(-4deg)}
// .svc h3{font-family:var(--serif);font-size:21px;line-height:1.25;margin-bottom:12px;color:var(--ink);font-weight:700}
// .svc p{font-size:14px;color:var(--muted);line-height:1.82;margin-bottom:22px}
// .svtags{display:flex;flex-wrap:wrap;gap:7px}
// .svtag{font-size:11px;font-weight:700;letter-spacing:.5px;color:var(--r);background:var(--rt);border:1px solid rgba(227,30,36,.15);padding:4px 12px;border-radius:100px}
// .svcarrow{position:absolute;bottom:26px;right:26px;width:34px;height:34px;border-radius:50%;border:1px solid var(--border);display:flex;align-items:center;justify-content:center;color:var(--muted);transition:all .25s var(--spring)}
// .svc:hover .svcarrow{background:var(--r);border-color:var(--r);color:#fff;transform:rotate(45deg)}

// /* CLIENT STORIES */
// .ststhdr{text-align:center;margin-bottom:72px}
// .ststhdr h2{font-family:var(--serif);font-size:clamp(34px,4vw,56px);line-height:1.1;margin-top:14px;font-weight:900}
// .ststgrid{display:grid;grid-template-columns:repeat(2,1fr);gap:28px}
// .sc{border-radius:28px;overflow:hidden;display:grid;grid-template-columns:195px 1fr 185px;min-height:330px;box-shadow:0 8px 40px rgba(0,0,0,.09);transition:transform .35s var(--spring),box-shadow .35s}
// .sc:hover{transform:translateY(-6px);box-shadow:0 28px 64px rgba(0,0,0,.15)}
// .scl{padding:32px 24px;display:flex;flex-direction:column;justify-content:space-between}
// .scm{padding:32px 22px;display:flex;flex-direction:column;justify-content:center;gap:22px}
// .scr{position:relative;overflow:hidden}
// .scr img{width:100%;height:100%;object-fit:cover;transition:transform .5s var(--ease)}
// .sc:hover .scr img{transform:scale(1.06)}
// .sc-logo{width:60px;height:60px;border-radius:50%;background:rgba(255,255,255,.18);display:flex;align-items:center;justify-content:center;border:2px solid rgba(255,255,255,.28);font-family:var(--serif);font-size:20px;font-weight:700;color:#fff;margin-bottom:16px}
// .sc-name{font-family:var(--serif);font-size:19px;line-height:1.2;font-weight:700}
// .sc-city{font-size:12px;opacity:.65;margin-top:3px;font-weight:500}
// .sc-div{height:1px;background:rgba(255,255,255,.18);margin:12px 0}
// .sc-cat{font-size:10px;font-weight:700;letter-spacing:1.2px;text-transform:uppercase;opacity:.55}
// .sc-desc{font-size:12px;opacity:.72;line-height:1.65;margin-top:8px}
// .sc-chs{display:flex;flex-wrap:wrap;gap:5px;margin-top:4px}
// .sc-ch{font-size:9px;font-weight:700;letter-spacing:.5px;border:1px solid rgba(255,255,255,.28);border-radius:100px;padding:3px 9px;opacity:.75}
// .sc-mlbl{font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;opacity:.55;margin-bottom:4px}
// .sc-mnum{font-family:var(--serif);font-size:50px;line-height:1;font-weight:900}
// .sc-msub{font-size:12px;opacity:.65;margin-top:3px;font-weight:500}
// .sc-svc li{font-size:12px;opacity:.78;padding:2px 0;font-weight:500}
// .sd{color:#fff}.sd .scl{background:#1a2456}.sd .scm{background:#1e2a62}
// .sr{color:#fff}.sr .scl{background:#b71c1c}.sr .scm{background:#c62828}
// .sn{color:#fff}.sn .scl{background:#0d2137}.sn .scm{background:#0f2d4a}
// .sf{color:#fff}.sf .scl{background:#1a3c2f}.sf .scm{background:#1e4a39}

// /* CLIENTS WALL */
// .clsec{background:var(--surf);padding:120px 44px}
// .clinn{max-width:1280px;margin:0 auto}
// .clhdr{text-align:center;margin-bottom:68px}
// .clhdr h2{font-family:var(--serif);font-size:clamp(32px,4vw,52px);line-height:1.1;margin-top:14px;font-weight:900}
// .clgrid{display:grid;grid-template-columns:repeat(6,1fr);gap:13px;margin-bottom:52px}
// .clcard{background:var(--white);border:1px solid var(--border);border-radius:15px;padding:20px 13px;display:flex;flex-direction:column;align-items:center;gap:9px;transition:border-color .3s,transform .3s var(--spring),box-shadow .3s;cursor:pointer}
// .clcard:hover{border-color:var(--r);transform:translateY(-5px);box-shadow:0 12px 36px var(--rg)}
// .clbox{width:58px;height:58px;border-radius:11px;background:var(--surf);overflow:hidden;display:flex;align-items:center;justify-content:center;padding:7px;transition:transform .3s var(--spring)}
// .clcard:hover .clbox{transform:scale(1.12)}
// .clbox img{width:100%;height:100%;object-fit:contain}
// .clfb{width:100%;height:100%;background:linear-gradient(135deg,var(--r),#ff6b35);border-radius:8px;display:flex;align-items:center;justify-content:center;color:#fff;font-family:var(--serif);font-size:16px;font-weight:700}
// .clname{font-size:10px;font-weight:700;color:var(--muted);text-align:center;line-height:1.3;letter-spacing:.3px}
// .cltrust{display:flex;border-radius:20px;overflow:hidden;border:1px solid var(--border)}
// .cttm{flex:1;padding:30px 22px;text-align:center;background:var(--white);border-right:1px solid var(--border)}
// .cttm:last-child{border-right:none}
// .cttn{font-family:var(--serif);font-size:clamp(22px,3vw,36px);line-height:1;background:linear-gradient(135deg,var(--r),#ff6b35);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;margin-bottom:5px;font-weight:900}
// .cttl{font-size:11px;color:var(--muted);font-weight:700;letter-spacing:.5px;text-transform:uppercase}

// /* INSTA */
// .instsec{padding:120px 0;background:var(--dark);overflow:hidden}
// .instinn{max-width:1280px;margin:0 auto;padding:0 44px}
// .insthdr{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:52px;flex-wrap:wrap;gap:24px}
// .insthdr h2{font-family:var(--serif);font-size:clamp(30px,4vw,52px);color:#fff;line-height:1.1;font-weight:900}
// .insthdr p{color:rgba(255,255,255,.42);font-size:15px;line-height:1.75;max-width:340px}
// .instsl{overflow:hidden;position:relative}
// .insttr{display:flex;gap:20px;transition:transform .6s var(--ease);will-change:transform}
// .instcard{flex-shrink:0;width:275px;border-radius:20px;overflow:hidden;background:#1a1a1a;border:1px solid rgba(255,255,255,.06);transition:transform .35s var(--spring),border-color .3s}
// .instcard:hover{transform:scale(1.03);border-color:rgba(227,30,36,.35)}
// .instimg{width:100%;height:195px;object-fit:cover}
// .instbody{padding:18px 18px 20px}
// .instprof{display:flex;align-items:center;gap:10px;margin-bottom:12px}
// .instav{width:34px;height:34px;border-radius:50%;object-fit:cover;border:2px solid rgba(255,255,255,.1);flex-shrink:0}
// .insth{font-size:13px;font-weight:700;color:#fff}
// .instf{font-size:11px;color:rgba(255,255,255,.38);margin-top:1px}
// .instcap{font-size:12px;color:rgba(255,255,255,.52);line-height:1.65}
// .insttag{display:inline-block;margin-top:10px;font-size:10px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--r);background:rgba(227,30,36,.1);border:1px solid rgba(227,30,36,.22);border-radius:100px;padding:3px 10px}
// .instnav{display:flex;align-items:center;gap:8px;margin-top:28px}
// .instnbtn{width:42px;height:42px;border-radius:50%;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.04);cursor:pointer;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.45);transition:all .25s}
// .instnbtn:hover{border-color:var(--r);background:var(--r);color:#fff}
// .instdot{height:8px;border-radius:100px;border:none;cursor:pointer;background:rgba(255,255,255,.18);transition:background .3s,width .3s;padding:0;flex-shrink:0}
// .instdot.on{background:var(--r);width:24px!important}

// /* ABOUT */
// .about{padding:140px 44px;max-width:1280px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:96px;align-items:center}
// .abl{position:relative}
// .abaccent{position:absolute;top:-20px;right:-20px;width:110px;height:110px;border-radius:50%;background:var(--rt);border:2px dashed rgba(227,30,36,.18);animation:slowspin 20s linear infinite;pointer-events:none}
// @keyframes slowspin{to{transform:rotate(360deg)}}
// .abdot{position:absolute;top:38px;right:38px;width:11px;height:11px;background:var(--r);border-radius:50%;animation:pdot 2.5s ease infinite}
// @keyframes pdot{0%,100%{box-shadow:0 0 0 0 var(--rg)}50%{box-shadow:0 0 0 11px transparent}}
// .abwrap{border-radius:32px;overflow:hidden;box-shadow:0 40px 80px rgba(0,0,0,.13)}
// .abwrap img{width:100%;height:540px;object-fit:cover;object-position:top}
// .abbadge{position:absolute;bottom:30px;left:30px;background:var(--white);border-radius:18px;padding:18px 22px;box-shadow:0 16px 48px rgba(0,0,0,.13);display:flex;gap:14px;align-items:center}
// .abbs{text-align:center}
// .abbsn{font-family:var(--serif);font-size:26px;line-height:1;color:var(--r);font-weight:900}
// .abbsl{font-size:10px;color:var(--muted);margin-top:3px;font-weight:700;letter-spacing:.5px;text-transform:uppercase}
// .abbdiv{width:1px;height:38px;background:var(--border)}
// .abr{}
// .abtit{font-family:var(--serif);font-size:clamp(30px,4vw,50px);line-height:1.1;margin-bottom:18px;font-weight:900;margin-top:14px}
// .abdesc{font-size:16px;color:var(--muted);line-height:1.85;margin-bottom:22px}
// .abq{border-left:3px solid var(--r);padding:15px 22px;background:var(--rt);border-radius:0 15px 15px 0;margin-bottom:38px}
// .abq p{font-family:var(--serif);font-size:16px;font-style:italic;color:var(--ink);line-height:1.6}
// .abq footer{font-size:11px;color:var(--r);font-weight:700;letter-spacing:.5px;text-transform:uppercase;margin-top:7px}
// .abteam{display:flex;flex-direction:column;gap:14px}
// .tm{display:flex;align-items:center;gap:16px;padding:18px;border:1px solid var(--border);border-radius:18px;transition:border-color .3s,box-shadow .3s}
// .tm:hover{border-color:var(--r);box-shadow:0 8px 32px var(--rg)}
// .tmav{width:60px;height:60px;border-radius:14px;background:linear-gradient(135deg,var(--r),#ff6b35);display:flex;align-items:center;justify-content:center;color:#fff;font-family:var(--serif);font-size:20px;font-weight:700;flex-shrink:0}
// .tname{font-family:var(--serif);font-size:17px;color:var(--ink);font-weight:700}
// .trole{font-size:11px;color:var(--r);font-weight:700;letter-spacing:.5px;text-transform:uppercase;margin-top:2px}
// .tbio{font-size:13px;color:var(--muted);margin-top:5px;line-height:1.55}
// .tbadge{margin-left:auto;background:var(--surf);border:1px solid var(--border);border-radius:12px;padding:9px 14px;text-align:center;flex-shrink:0}
// .tbnum{font-family:var(--serif);font-size:20px;line-height:1;color:var(--r);font-weight:900}
// .tblbl{font-size:9px;color:var(--muted);font-weight:700;letter-spacing:.8px;text-transform:uppercase;margin-top:2px}

// /* CTA */
// .ctaband{background:var(--r);padding:100px 44px;text-align:center;overflow:hidden;position:relative}
// .ctabg{position:absolute;inset:0;background:repeating-linear-gradient(-45deg,rgba(255,255,255,.02) 0,rgba(255,255,255,.02) 1px,transparent 1px,transparent 20px)}
// .ctainn{position:relative;max-width:680px;margin:0 auto}
// .ctainn h2{font-family:var(--serif);font-size:clamp(34px,5vw,62px);color:#fff;line-height:1.05;margin-bottom:18px;font-weight:900}
// .ctainn p{font-size:16px;color:rgba(255,255,255,.62);line-height:1.75;margin-bottom:44px}
// .ctabtns{display:flex;gap:14px;justify-content:center;flex-wrap:wrap}
// .bw{display:inline-flex;align-items:center;gap:8px;padding:14px 32px;border-radius:100px;background:#fff;color:var(--r);font-family:var(--sans);font-size:14px;font-weight:700;border:none;cursor:pointer;box-shadow:0 8px 24px rgba(0,0,0,.14);transition:transform .25s var(--spring)}
// .bw:hover{transform:translateY(-3px)}
// .bow{display:inline-flex;align-items:center;gap:8px;padding:14px 32px;border-radius:100px;background:transparent;color:#fff;font-family:var(--sans);font-size:14px;font-weight:600;border:1.5px solid rgba(255,255,255,.32);cursor:pointer;transition:border-color .2s,background .2s}
// .bow:hover{border-color:#fff;background:rgba(255,255,255,.1)}

// /* RESPONSIVE */
// @media(max-width:1024px){
//   .hero{grid-template-columns:1fr}
//   .hright{display:none}
//   .hleft{padding:120px 44px 80px;max-width:none}
//   .svgrid{grid-template-columns:repeat(2,1fr)}
//   .ststgrid{grid-template-columns:1fr}
//   .sc{grid-template-columns:175px 1fr 155px}
//   .clgrid{grid-template-columns:repeat(4,1fr)}
//   .about{grid-template-columns:1fr;gap:56px}
//   .abwrap img{height:380px}
//   .svhdr{grid-template-columns:1fr;gap:16px}
// }
// @media(max-width:768px){
//   .nlinks{display:none}.nbg{display:flex}.nw{padding:0 24px}
//   .hleft{padding:100px 24px 60px}
//   .svsec{padding:80px 24px}
//   .svgrid{grid-template-columns:1fr}
//   .ststgrid{grid-template-columns:1fr}
//   .sc{grid-template-columns:1fr;grid-template-rows:auto auto 190px}
//   .scr{height:190px}
//   .clsec{padding:80px 24px}
//   .clgrid{grid-template-columns:repeat(3,1fr);gap:10px}
//   .instinn{padding:0 24px}
//   .about{padding:80px 24px}
//   .ctaband{padding:80px 24px}
//   .hstats{flex-wrap:wrap;gap:20px}
//   .hst+.hst{padding-left:0;border-left:none;margin-left:0;min-width:45%}
//   .cltrust{flex-direction:column;border-radius:16px}
//   .cttm{border-right:none;border-bottom:1px solid var(--border)}
//   .cttm:last-child{border-bottom:none}
// }
// @media(max-width:480px){
//   .clgrid{grid-template-columns:repeat(2,1fr)}
//   .htitle{font-size:38px}
//   .instcard{width:240px}
// }
// `;

// /* ═══════════════════ DATA ═══════════════════ */
// const SVCS = [
//   { icon:'📱', title:'Content Creation + Social Media', desc:'We create sales-driven content that conveys your product to your target audience and attracts organic traffic through infographics, videos, reels and strategic collaborations.', tags:['Instagram','YouTube','LinkedIn','Reels'] },
//   { icon:'🎯', title:'Lead Generation + Digital Campaigns', desc:'We develop marketing funnels, craft creatives & copywriting, run promotions, optimize budgets and analyze campaign performance across Facebook, Instagram & Google Ads.', tags:['Facebook Ads','Google Ads','Meta Ads','Analytics'] },
//   { icon:'🌐', title:'Corporate Branding & Web Design', desc:'We create corporate identity for your brand through design expertise in branding, packaging and websites — delivering a clear message through copy and creative graphics.', tags:['Logo Design','Packaging','Website','UI/UX'] },
//   { icon:'🔍', title:'Search Engine Optimization', desc:'We drive organic search visibility with technical SEO, keyword strategy, on-page optimization and authority link building that ranks your brand above the competition.', tags:['On-Page SEO','Technical SEO','Link Building','Rankings'] },
//   { icon:'🎨', title:'Graphic Design & Video Production', desc:'From social media creatives and ad banners to promotional videos and motion graphics — visuals that stop the scroll and communicate your brand story powerfully.', tags:['Ad Creatives','Motion Graphics','Video Editing','Branding'] },
//   { icon:'📊', title:'Analytics & Strategy Consulting', desc:'Data-led decisions. We track every campaign metric, build custom reports and translate numbers into clear growth strategies your team can act on immediately.', tags:['GA4','Meta Pixel','Reporting','CRO'] },
// ];

// const STORIES = [
//   { v:'sd', name:'Zuri Skin Clinic', city:'Hyderabad', cat:'Health Care', desc:'Quality skin, hair & nail care with top dermatologists and cutting-edge procedures.', leads:'1000', dur:'8 Months', svcs:['Social Media','Website','Lead Gen Campaigns For Admissions'], chs:['Facebook','Instagram','YouTube','Google'], img:'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400&h=340&fit=crop', init:'ZS' },
//   { v:'sr', name:'Design Walls', city:'Hyderabad', cat:'Wall Papers & Furnishings', desc:'A leading wall paper company known for customisable designs, great collection & speedy service.', leads:'3500', dur:'8 Months', svcs:['Social Media','Website','Lead Gen Campaigns'], chs:['Facebook','Instagram','YouTube','Google'], img:'https://images.unsplash.com/photo-1615873968403-89e068629265?w=400&h=340&fit=crop', init:'DW' },
//   { v:'sn', name:'Millet Marvels', city:'Hyderabad', cat:'Food & Nutrition', desc:'MILLET EXPERIENCE HUB — serving 100% wholegrain goodness to health-conscious India.', leads:'9,621', dur:'6 Months', svcs:['Instagram Growth','Brand Collabs','Content Creation'], chs:['Instagram','YouTube','Google'], img:'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=400&h=340&fit=crop', init:'MM' },
//   { v:'sf', name:'Indic International School', city:'Secunderabad', cat:'Education', desc:'Education that sets u free — engaging young minds through exciting activities and modern pedagogy.', leads:'1,096', dur:'5 Months', svcs:['Social Media','Lead Gen','Content Creation'], chs:['Facebook','Instagram','Google'], img:'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=400&h=340&fit=crop', init:'IS' },
// ];

// const CLIENTS_DATA = [
//   { name:'Green Leaves', logo:greenleavesLogo },
//   { name:'Construction Insides', logo:constructionLogo2 },
//   { name:'Hyderabad Property', logo:HyderabadPropertyLogo },
//   { name:'Ideal Kitchen', logo:IdealKitchenLogo },
//   { name:'Nihira Realtors', logo:nihirarealtorsLogo },
//   { name:'Old City Food Truck', logo:oldCityFoodTruckLogo },
//   { name:'Orion', logo:OrionLogo },
//   { name:'Rao Travels', logo:raoTravelsLogo },
//   { name:'Vedamsa', logo:vedamsaLogo },
//   { name:'Red Yards', logo:redYardsLogo },
//   { name:'JJ Wellness Clinic', logo:jj },
//   { name:'Amista', logo:AmistaLogo },
//   { name:'SIA Clinics', logo:siaLogo },
//   { name:'Meble', logo:mebelLogo },
//   { name:'Sattva', logo:sattvaLogo },
//   { name:'Shree Suvidha', logo:shreesuvidhaLogo },
//   { name:'Carnival Castle', logo:carnivalLogo },
//   { name:'Kalyani Constructions', logo:kalyani },
// ];

// const INSTA = [
//   { h:'@milletmarvels', f:'9,621 followers', cap:'Farm Fresh Millets with Natural Nutrition. Changing the way India eats — one meal a day.', tag:'Social Media Growth', img:'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=280&h=195&fit=crop' },
//   { h:'@indicschools', f:'1,096 followers', cap:'Indic International School — education that sets u free. Engaging young minds every day.', tag:'Education Marketing', img:'https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=280&h=195&fit=crop' },
//   { h:'@triumph_hyd', f:'1,841 followers', cap:'Ride the award-winning adventure — Triumph Motorcycles Hyderabad. Own the open road.', tag:'Automotive Branding', img:'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=280&h=195&fit=crop' },
//   { h:'@designwalls_hyd', f:'3,500 leads gen', cap:'Soft Dark Accents in Sophisticated Styles. Premium blackout curtains & wallpapers.', tag:'Interior Design Ads', img:'https://images.unsplash.com/photo-1615873968403-89e068629265?w=280&h=195&fit=crop' },
//   { h:'@zuriskinclinic', f:'1,000+ leads', cap:'Awaken Your Glow — Consult with our Dermatologists for all your skin concerns. Book now.', tag:'Healthcare Campaigns', img:'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=280&h=195&fit=crop' },
//   { h:'@kanactify', f:'2K+ community', cap:"Branding Irreversible. We turn your digital mediums into lead generation machines.", tag:'Agency Portfolio', img:'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=280&h=195&fit=crop' },
// ];

// const MQ = ['Social Media Marketing','Lead Generation','Google Ads','Meta Ads','Brand Identity','Web Design','Content Creation','SEO'];

// /* ═══════════════════ HELPERS ═══════════════════ */
// function useReveal() {
//   useEffect(() => {
//     const o = new IntersectionObserver(
//       es => es.forEach(e => { if(e.isIntersecting) e.target.classList.add('in'); }),
//       { threshold: 0.07 }
//     );
//     document.querySelectorAll('.rv,.rv-l,.rv-r').forEach(el => o.observe(el));
//     return () => o.disconnect();
//   });
// }

// function CLCard({ name, logo }) {
//   const [err, setErr] = useState(false);
//   const i = name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
//   return (
//     <div className="clcard">
//       <div className="clbox">
//         {!err ? <img src={logo} alt={name} onError={()=>setErr(true)} /> : <div className="clfb">{i}</div>}
//       </div>
//       <div className="clname">{name}</div>
//     </div>
//   );
// }

// /* ═══════════════════ MAIN ═══════════════════ */
// const PremiumWebsite = () => {
//   const [stuck, setStuck]     = useState(false);
//   const [mOpen, setMOpen]     = useState(false);
//   const [iIdx, setIIdx]       = useState(0);
//   const CARD_W = 275 + 20;
//   const MAX_I  = INSTA.length - 3;

//   useEffect(() => {
//     const f = () => setStuck(window.scrollY > 60);
//     window.addEventListener('scroll', f);
//     return () => window.removeEventListener('scroll', f);
//   }, []);

//   useEffect(() => {
//     const t = setInterval(() => setIIdx(p => p >= MAX_I ? 0 : p + 1), 3200);
//     return () => clearInterval(t);
//   }, [MAX_I]);

//   useReveal();

//   const go = id => { document.getElementById(id)?.scrollIntoView({ behavior:'smooth' }); setMOpen(false); };

//   return (
//     <div>
//       <style>{G}</style>
//       <NavigationIndicators />
//       <Chatbot />

//       {/* NAV */}
//       <nav className={`nav${stuck?' st':''}`}>
//         <div className="nw">
//           <div className="nlogo"><img src={KanactfyLogo} alt="K" />Kan<span>actify</span></div>
//           <div className="nlinks">
//             {[['home','Home'],['services','Services'],['stories','Case Studies'],['clients','Clients'],['about','About']].map(([id,l])=>(
//               <a key={id} href={`#${id}`} onClick={e=>{e.preventDefault();go(id)}}>{l}</a>
//             ))}
//             <button className="ncta" onClick={()=>go('contact')}>Get Started</button>
//           </div>
//           <button className="nbg" onClick={()=>setMOpen(true)}><span/><span/><span/></button>
//         </div>
//       </nav>

//       {/* MOBILE MENU */}
//       <div className={`mobmenu${mOpen?' op':''}`}>
//         <button className="mcx" onClick={()=>setMOpen(false)}><X size={28}/></button>
//         {[['home','Home'],['services','Services'],['stories','Case Studies'],['clients','Clients'],['about','About']].map(([id,l])=>(
//           <a key={id} href={`#${id}`} onClick={e=>{e.preventDefault();go(id)}}>{l}</a>
//         ))}
//         <button className="ncta" onClick={()=>go('contact')}>Get Started</button>
//       </div>

//       {/* HERO */}
//       <section id="home">
//         <div className="mqbar" style={{marginTop:'72px'}}>
//           <div className="mqinner">
//             {[...MQ,...MQ].map((t,i)=><span key={i} className="mqitem">{t}<span className="mqstar">★</span></span>)}
//           </div>
//         </div>
//         <div className="hero">
//           <div className="hleft">
//             <div className="htag rv"><div className="ptag"><span className="pdot"/>  #1 Digital Marketing Agency · Hyderabad</div></div>
//             <h1 className="htitle rv d1">We Turn Your<br/><em>Digital Mediums</em><br/>Into Lead Generation<br/>Machines.</h1>
//             <p className="hdesc rv d2">As a top digital marketing agency in Hyderabad, we research, develop strategy and create compelling content that defines your brand, builds funnels and launches campaigns that convert.</p>
//             <div className="hbtns rv d3">
//               <button className="bp" onClick={()=>go('contact')}>Start Growing <ArrowUpRight size={16}/></button>
//               <button className="bg" onClick={()=>go('stories')}>View Case Studies</button>
//             </div>
//             <div className="hstats rv d4">
//               {[['200+','Brands Served'],['50M+','Impressions'],['8+','Years Exp.'],['98%','Retention']].map(([n,l])=>(
//                 <div key={l} className="hst"><div className="hstn">{n}</div><div className="hstl">{l}</div></div>
//               ))}
//             </div>
//           </div>
//           <div className="hright">
//             <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=900&h=900&fit=crop" alt="team"/>
//             <div className="hright-ov"/>
//           </div>
//         </div>
//       </section>

//       {/* SERVICES */}
//       <section id="services">
//         <div className="svsec">
//           <div className="svhdr">
//             <div>
//               <div className="ptag rv">What We Do</div>
//               <h2 className="rv d1">Services That <span className="gt">Drive Results</span></h2>
//             </div>
//             <div className="rv d2">
//               <p>Comprehensive digital marketing — from strategy and content to paid campaigns and brand identity — all under one roof.</p>
//               <div className="svlm" onClick={()=>go('contact')}>Let's build your strategy <ArrowUpRight size={16}/></div>
//             </div>
//           </div>
//           <div className="svgrid">
//             {SVCS.map((s,i)=>(
//               <div key={i} className={`svc rv d${Math.min(i%3+1,3)}`}>
//                 <div className="svcn">0{i+1}</div>
//                 <div className="svcicon"><span>{s.icon}</span></div>
//                 <h3>{s.title}</h3>
//                 <p>{s.desc}</p>
//                 <div className="svtags">{s.tags.map(t=><span key={t} className="svtag">{t}</span>)}</div>
//                 <div className="svcarrow"><ArrowUpRight size={15}/></div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CLIENT STORIES */}
//       <section id="stories" style={{background:'var(--surf)',paddingTop:'120px'}}>
//         <div style={{padding:'0 44px 120px',maxWidth:'1280px',margin:'0 auto'}}>
//           <div className="ststhdr">
//             <div className="ptag rv">Success Stories</div>
//             <h2 className="rv d1">Our Client <span className="gt">Stories</span></h2>
//           </div>
//           <div className="ststgrid">
//             {STORIES.map((s,i)=>(
//               <div key={i} className={`sc ${s.v} rv d${i%2===0?1:2}`}>
//                 <div className="scl">
//                   <div>
//                     <div className="sc-logo">{s.init}</div>
//                     <div className="sc-name">{s.name}</div>
//                     <div className="sc-city">{s.city}</div>
//                     <div className="sc-div"/>
//                     <div className="sc-cat">{s.cat}</div>
//                     <div className="sc-desc">{s.desc}</div>
//                   </div>
//                   <div className="sc-chs">{s.chs.map(c=><span key={c} className="sc-ch">{c}</span>)}</div>
//                 </div>
//                 <div className="scm">
//                   <div>
//                     <div className="sc-mlbl">Leads Generated</div>
//                     <div className="sc-mnum">{s.leads}</div>
//                   </div>
//                   <div>
//                     <div className="sc-mlbl">Duration</div>
//                     <div style={{fontFamily:'var(--serif)',fontSize:'30px',lineHeight:1,fontWeight:900,marginTop:'4px'}}>{s.dur}</div>
//                   </div>
//                   <div className="sc-svc">
//                     <div className="sc-mlbl">Services</div>
//                     <ul>{s.svcs.map(sv=><li key={sv}>· {sv}</li>)}</ul>
//                   </div>
//                 </div>
//                 <div className="scr"><img src={s.img} alt={s.name}/></div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CLIENT LOGOS */}
//       <section id="clients" className="clsec">
//         <div className="clinn">
//           <div className="clhdr">
//             <div className="ptag rv">Our Network</div>
//             <h2 className="rv d1">Trusted by <span className="gt">Industry Leaders</span></h2>
//           </div>
//           <div className="clgrid">
//             {CLIENTS_DATA.map(c=><div key={c.name} className="rv"><CLCard name={c.name} logo={c.logo}/></div>)}
//           </div>
//           <div className="cltrust rv">
//             {[['200+','Brands Served'],['50M+','Impressions'],['150+','Campaigns'],['98%','Retention']].map(([n,l],i,a)=>(
//               <div key={l} className="cttm" style={i===a.length-1?{borderBottom:'none'}:{}}>
//                 <div className="cttn">{n}</div>
//                 <div className="cttl">{l}</div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* INSTA SHOWCASE */}
//       <section className="instsec">
//         <div className="instinn">
//           <div className="insthdr">
//             <div>
//               <div className="ptag" style={{background:'rgba(227,30,36,.1)',borderColor:'rgba(227,30,36,.25)',color:'var(--r)'}}>Client Instagram Pages</div>
//               <h2 className="rv d1">Real Results,<br/><span className="gt">Real Profiles</span></h2>
//             </div>
//             <p className="rv d2">We manage and grow Instagram pages that convert — here's a live snapshot of client feeds we've built and scaled from scratch.</p>
//           </div>
//           <div className="instsl">
//             <div className="insttr" style={{transform:`translateX(-${iIdx*CARD_W}px)`}}>
//               {INSTA.map((p,i)=>(
//                 <div key={i} className="instcard">
//                   <img className="instimg" src={p.img} alt={p.h}/>
//                   <div className="instbody">
//                     <div className="instprof">
//                       <div className="instav" style={{background:'linear-gradient(135deg,var(--r),#ff6b35)',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:'13px',fontWeight:800}}>{p.h[1].toUpperCase()}</div>
//                       <div><div className="insth">{p.h}</div><div className="instf">{p.f}</div></div>
//                     </div>
//                     <div className="instcap">{p.cap}</div>
//                     <span className="insttag">{p.tag}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="instnav">
//             <button className="instnbtn" onClick={()=>setIIdx(p=>Math.max(0,p-1))}><ChevronLeft size={17}/></button>
//             <button className="instnbtn" onClick={()=>setIIdx(p=>Math.min(MAX_I,p+1))}><ChevronRight size={17}/></button>
//             {Array.from({length:MAX_I+1}).map((_,i)=>(
//               <button key={i} className={`instdot${iIdx===i?' on':''}`} style={{width:iIdx===i?'24px':'8px'}} onClick={()=>setIIdx(i)}/>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ABOUT */}
//       <section id="about">
//         <div className="about">
//           <div className="abl rv-l">
//             <div className="abaccent"/>
//             <div className="abwrap">
//               <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=700&h=540&fit=crop" alt="Kanactify team"/>
//               <div className="abwrap abwrap-dot"><div className="abwrap"/></div>
//               <div className="abwrap" style={{position:'static'}}/>
//               <div style={{position:'absolute',top:'36px',right:'36px',width:'11px',height:'11px',background:'var(--r)',borderRadius:'50%',animation:'pdot 2.5s ease infinite'}}/>
//             </div>
//             <div className="abbadge">
//               {[['2018','Est. Year'],['200+','Brands'],['8+','Years']].reduce((acc,item,i,arr)=>{
//                 acc.push(<div key={i} className="abbs"><div className="abbsn">{item[0]}</div><div className="abbsl">{item[1]}</div></div>);
//                 if(i<arr.length-1) acc.push(<div key={`d${i}`} className="abbdiv"/>);
//                 return acc;
//               },[])}
//             </div>
//           </div>
//           <div className="abr rv-r">
//             <div style={{marginBottom:'22px'}}><div className="ptag">About Kanactify</div></div>
//             <h2 className="abtit">Hyderabad's Most Trusted <span className="gt">Digital Growth Partner</span></h2>
//             <p className="abdesc">Founded in 2018, Kanactify started with a simple belief — every business deserves a powerful digital presence. Today, we're a full-service digital marketing agency helping 200+ brands across India research, strategise, create and scale.</p>
//             <p className="abdesc" style={{marginTop:'-10px'}}>We've generated 50M+ impressions, launched hundreds of campaigns across Meta, Google & YouTube, and built brand identities that people remember and trust.</p>
//             <div className="abq">
//               <p>"Branding is irreversible — it's the most powerful investment a business can make in itself."</p>
//               <footer>— Founder & CEO, Kanactify</footer>
//             </div>
//             <div className="abteam">
//               <div className="tm">
//                 <div className="tmav">K</div>
//                 <div>
//                   <div className="tname">Founder & CEO</div>
//                   <div className="trole">Chief Executive Officer</div>
//                   <div className="tbio">Visionary behind Kanactify's growth philosophy. 8+ years transforming brands through digital strategy and creative execution.</div>
//                 </div>
//                 <div className="tbadge"><div className="tbnum">8+</div><div className="tblbl">Yrs Exp</div></div>
//               </div>
//               <div className="tm">
//                 <div className="tmav" style={{background:'linear-gradient(135deg,#1a2456,#2d3a8c)'}}>S</div>
//                 <div>
//                   <div className="tname">Head of Campaigns</div>
//                   <div className="trole">Strategy & Creative Lead</div>
//                   <div className="tbio">Crafts data-driven campaigns across Meta, Google & YouTube that consistently deliver measurable ROI for clients.</div>
//                 </div>
//                 <div className="tbadge"><div className="tbnum">150+</div><div className="tblbl">Campaigns</div></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section id="contact" className="ctaband">
//         <div className="ctabg"/>
//         <div className="ctainn rv">
//           <div className="ptag" style={{background:'rgba(255,255,255,.12)',borderColor:'rgba(255,255,255,.25)',color:'#fff',marginBottom:'22px'}}>Ready to Grow?</div>
//           <h2>Let's Turn Your Brand Into a <em>Lead Machine</em></h2>
//           <p>Join 200+ businesses across Hyderabad who trust Kanactify to grow their digital presence and generate quality leads every single month.</p>
//           <div className="ctabtns">
//             <a className="bw" href="tel:+919500000000">📞 Call Us Now</a>
//             <a className="bow" href="https://wa.me/919500000000" target="_blank" rel="noreferrer">💬 WhatsApp Us</a>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default PremiumWebsite;

import React, { useState, useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight, X, ArrowUpRight } from "lucide-react";
import VideoHero from './VideoSection';
import MediaRecognitionSection from "./MediaRecognitionSection";
import greenleavesLogo from "./ClientLogos/greenleavesLogo.png";
import HyderabadPropertyLogo from "./ClientLogos/HyderabadPropertyLogo.png";
import KanactfyLogo from "./ClientLogos/kanactifyLogo.jpeg";
import IdealKitchenLogo from "./ClientLogos/IdealKitchenLogo.png";
import nihirarealtorsLogo from "./ClientLogos/nihirarealtorsLogo.png";
import oldCityFoodTruckLogo from "./ClientLogos/oldCityFoodTruckLogo.png";
import OrionLogo from "./ClientLogos/OrionLogo.png";
import raoTravelsLogo from "./ClientLogos/raoTravelsLogo.png";
import vedamsaLogo from "./ClientLogos/vedamsaLogo.png";
import redYardsLogo from "./ClientLogos/redYardsLogo.png";
import constructionLogo2 from "./ClientLogos/constructionLogo.png";
import jj from "./ClientLogos/JJ.png";
import AmistaLogo from "./ClientLogos/Amista logo.png";
import siaLogo from "./ClientLogos/SIA CLINICS.png";
import mebelLogo from "./ClientLogos/Meble-Logo (1).png";
import sattvaLogo from "./ClientLogos/Sattva-Logo-1.png";
import shreesuvidhaLogo from "./ClientLogos/Shree Suvidha logo.png";
import carnivalLogo from "./ClientLogos/Carnival Castle.png";
import kalyani from "./ClientLogos/kalyani.jpeg";
import Athidi from "./ClientLogos/Athidi logo.jpg.jpeg";
import BloomTheropy from './ClientLogos/Bloom Theropy Logo.png 01.jpg.jpeg';
import BrowniePoint from './ClientLogos/Brownie_Point_Logo1.png';
import Bvb from './ClientLogos/BVB (1).png';
import chemistry from './ClientLogos/Chemistry Logo.png';
import Chikoo from './ClientLogos/Chikoo-&-Cookie-Play-Zone-&-Party-Logo.png';
import cloud from './ClientLogos/Cloud Logo.png';
import Dharva from './ClientLogos/Dharva logo 2 (1).png';
import KSEducational from './ClientLogos/KS Educational.png';
import LotusDiagnostics from './ClientLogos/Lotus-Diagnostics-Logo-Png.png';
import mandiKhebab from './ClientLogos/mandi kebab logo.png';
import MkDecor from './ClientLogos/MK DECOR logo.png';
import Sedyam from './ClientLogos/Sedyam telugu logo.png';
import SkinShine from './ClientLogos/Skin shine 01.png';
import  VayuClinics from './ClientLogos/Vayu Clinics.png';

import Chatbot from "./chatbot";
import NavigationIndicators from "./NavIndiacator";
import ContactSection from "./contact";
import InstagramShowcase from "./instaShowCase";
import PremiumFooter from "./footer";
import Navbar from "./navbar";
import ceoImage from './insta/ceo.jpeg';

/* ─────────────────────────────────────────────────
   REVEAL COMPONENTS
───────────────────────────────────────────────── */
const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);
  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => { entries.forEach(e => { if (e.isIntersecting) { setIsRevealed(true); observer.unobserve(el); } }); },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, []);
  return (
    <div ref={wrapperRef} className={className} style={{position:"relative",overflow:"hidden"}}>
      <img src={src} alt={alt} style={{width:"100%",height:"100%",objectFit:"cover",position:"relative",zIndex:1,transition:"opacity 1500ms ease-out",transitionDelay:"800ms",opacity:isRevealed?1:0}}/>
      <div style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",zIndex:2,transition:"transform 1500ms cubic-bezier(0.77,0,0.175,1)",transform:isRevealed?"scaleX(0)":"scaleX(1)",transformOrigin:isRevealed?"right":"left",background:"linear-gradient(90deg,#C0C0C0 0%,#E8E8E8 25%,#FFF 50%,#E8E8E8 75%,#C0C0C0 100%)"}}/>
      <div style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",zIndex:3,transition:"opacity 1500ms cubic-bezier(0.77,0,0.175,1), transform 1500ms cubic-bezier(0.77,0,0.175,1)",transitionDelay:"300ms",opacity:isRevealed?0:1,transform:isRevealed?"translateX(100%)":"translateX(0)",background:"linear-gradient(90deg,transparent 0%,rgba(255,255,255,.8) 50%,transparent 100%)"}}/>
    </div>
  );
};

const RevealContent = ({ children, className = "", delay = 0, style = {} }) => {
  const ref = useRef();
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    const observer = new IntersectionObserver(
      entries => { entries.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); observer.unobserve(el); } }); },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, [delay]);
  return (
    <div ref={ref} className={className} style={{transition:"opacity 900ms cubic-bezier(0.4,0,0.2,1), transform 900ms cubic-bezier(0.4,0,0.2,1)",opacity:on?1:0,transform:on?"translateY(0)":"translateY(60px)",...style}}>
      {children}
    </div>
  );
};

const RevealLine = ({ children, delay = 0, style = {} }) => {
  const ref = useRef();
  const [on, setOn] = useState(false);
  useEffect(() => {
    const el = ref.current;
    const observer = new IntersectionObserver(
      entries => { entries.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); observer.unobserve(el); } }); },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, [delay]);
  return (
    <div ref={ref} style={{overflow:"hidden",...style}}>
      <div style={{transition:"transform 1000ms cubic-bezier(0.77,0,0.175,1)",transform:on?"translateY(0)":"translateY(110%)",transitionDelay:delay+"ms"}}>
        {children}
      </div>
    </div>
  );
};



/* ─────────────────────────────────────────────────
   CSS
───────────────────────────────────────────────── */
// ─────────────────────────────────────────────────────────────────────────────
// RESPONSIVE PATCH — drop this file beside your existing PremiumWebsite.jsx
// and replace the G (CSS string) + StoryCard + main render section.
//
// Changes summary:
//  • Full mobile-first breakpoints for all sections
//  • StoryCard stacks vertically on mobile (logo → metrics row → image)
//  • Hero padding / font sizes tuned for 320-480px
//  • CEO card single-column with smaller image on mobile
//  • Client logos 2-col on very small, 3-col on 480+, 4-col on 768+
//  • Marquee, nav, CTA, about — all tightened
//  • Story slider dots/nav always visible and tap-friendly (44px targets)
//  • Overflow / horizontal scroll eliminated globally
// ─────────────────────────────────────────────────────────────────────────────

// ── Replace the G constant in your file with this ──────────────────────────
export const G = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700;1,900&family=DM+Sans:wght@300;400;500;600;700&display=swap');

:root{
  --or:#F86C3D;   --dor:#D9572E;   --sor:#FF8A5C;   --yor:#FFF0EA;
  --og:rgba(248,108,61,.18);  --ot:rgba(248,108,61,.08);  --ot2:rgba(248,108,61,.04);
  --ink:#0A0A0A;  --ink2:#1A1209;  --muted:#705848;  --muted2:#9A8070;
  --border:#F0E0D0;  --border2:rgba(248,108,61,.15);
  --surf:#FDF8F4;  --dark:#0D0806;  --cream:#FFFCF9;  --white:#FFFFFF;
  --serif:"Playfair Display",Georgia,serif;
  --sans:"DM Sans",sans-serif;
  --sp:cubic-bezier(.34,1.56,.64,1);
  --ez:cubic-bezier(.4,0,.2,1);
  --ez2:cubic-bezier(.77,0,.175,1);
}
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth}
body{font-family:var(--sans);background:var(--cream);color:var(--ink);-webkit-font-smoothing:antialiased;overflow-x:hidden}
a{text-decoration:none;color:inherit}ul{list-style:none}img{display:block;max-width:100%}
.gto{background:linear-gradient(135deg,var(--or),var(--sor));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.gtod{background:linear-gradient(135deg,var(--dor),var(--or));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.ptag{display:inline-flex;align-items:center;gap:7px;background:var(--ot);color:var(--dor);border:1px solid var(--border2);border-radius:100px;padding:6px 18px;font-family:var(--sans);font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase}
.pdot{width:6px;height:6px;background:var(--or);border-radius:50%;animation:pd 2s infinite}
@keyframes pd{0%,100%{box-shadow:0 0 0 0 var(--og)}50%{box-shadow:0 0 0 8px transparent}}

/* ── NAV ─────────────────────────────────────────────────────────────────── */
.nav{position:fixed;top:0;left:0;right:0;z-index:500;padding:20px 0;transition:background .4s var(--ez),padding .4s,box-shadow .4s}
.nav.st{background:rgba(255,252,249,.97);backdrop-filter:blur(28px);padding:13px 0;box-shadow:0 1px 0 var(--border),0 8px 48px rgba(248,108,61,.08)}
.nw{max-width:1280px;margin:0 auto;padding:0 44px;display:flex;align-items:center;justify-content:space-between}
.nlogo{display:flex;align-items:center;gap:10px;font-family:var(--sans);font-size:19px;font-weight:800;color:var(--ink)}
.nlogo img{width:36px;height:36px;border-radius:9px;object-fit:cover;border:2px solid var(--border2)}
.nlogo .oa{color:var(--or)}
.nl{display:flex;align-items:center;gap:34px}
.nl a{font-size:14px;font-weight:600;color:var(--muted);transition:color .2s;position:relative}
.nl a::after{content:"";position:absolute;bottom:-4px;left:0;right:0;height:1.5px;background:linear-gradient(90deg,var(--dor),var(--sor));transform:scaleX(0);transform-origin:right;transition:transform .3s var(--ez)}
.nl a:hover{color:var(--ink)}
.nl a:hover::after{transform:scaleX(1);transform-origin:left}
.ncta{padding:11px 26px;border-radius:100px;background:linear-gradient(135deg,var(--or),var(--dor));color:#fff;font-family:var(--sans);font-size:13px;font-weight:700;border:none;cursor:pointer;box-shadow:0 6px 24px var(--og);transition:transform .25s var(--sp),box-shadow .25s}
.ncta:hover{transform:translateY(-2px) scale(1.02);box-shadow:0 12px 32px var(--og)}
.nbg{display:none;background:none;border:none;cursor:pointer;padding:8px 4px;flex-direction:column;gap:5px;min-width:44px;min-height:44px;justify-content:center;align-items:center}
.nbg span{width:24px;height:1.5px;background:var(--ink);display:block;border-radius:2px}
.mm{position:fixed;inset:0;z-index:499;background:rgba(255,252,249,.98);backdrop-filter:blur(20px);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:36px;opacity:0;pointer-events:none;transition:opacity .3s}
.mm.op{opacity:1;pointer-events:all}
.mm a{font-family:var(--serif);font-size:38px;color:var(--ink);transition:color .2s}
.mm a:hover{color:var(--or)}
.mcx{position:absolute;top:28px;right:36px;background:none;border:none;cursor:pointer;min-width:44px;min-height:44px;display:flex;align-items:center;justify-content:center}

/* ── MARQUEE ─────────────────────────────────────────────────────────────── */
.mbar{overflow:hidden;border-top:1px solid var(--border);border-bottom:1px solid var(--border);padding:14px 0;mask:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent);-webkit-mask:linear-gradient(90deg,transparent,#000 8%,#000 92%,transparent);background:var(--yor)}
.min{display:flex;width:max-content;animation:mq 32s linear infinite}
.mi{display:flex;align-items:center;gap:14px;padding:0 28px;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:var(--muted);white-space:nowrap}
.ms{color:var(--or);font-size:10px}
@keyframes mq{from{transform:translateX(0)}to{transform:translateX(-50%)}}

/* ── HERO ────────────────────────────────────────────────────────────────── */
.hero{min-height:100vh;display:grid;grid-template-columns:1fr 1fr;align-items:center;background:var(--cream)}
.hl{padding:130px 0 80px 44px;max-width:660px}
.hr{position:relative;height:100vh;overflow:hidden}
.hro{position:absolute;inset:0;background:linear-gradient(to right,var(--cream) 0%,rgba(255,252,249,0) 35%)}
.htag{margin-bottom:32px}
.ht{font-family:var(--serif);font-size:clamp(44px,5.5vw,82px);line-height:1.03;color:var(--ink);margin-bottom:26px;font-weight:900}
.ht em{font-style:italic;color:var(--or)}
.hd{font-size:17px;color:var(--muted);line-height:1.85;max-width:480px;margin-bottom:48px;font-weight:400}
.hbt{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:72px}
.bp{display:inline-flex;align-items:center;gap:8px;padding:15px 34px;border-radius:100px;background:linear-gradient(135deg,var(--or),var(--dor));color:#fff;font-family:var(--sans);font-size:14px;font-weight:700;border:none;cursor:pointer;box-shadow:0 10px 32px var(--og);transition:transform .25s var(--sp),box-shadow .25s}
.bp:hover{transform:translateY(-3px);box-shadow:0 18px 48px var(--og)}
.bg2{display:inline-flex;align-items:center;gap:8px;padding:15px 34px;border-radius:100px;background:transparent;color:var(--ink);font-family:var(--sans);font-size:14px;font-weight:600;border:1.5px solid var(--border);cursor:pointer;transition:border-color .2s,color .2s,transform .2s}
.bg2:hover{border-color:var(--or);color:var(--or);transform:translateY(-2px)}
.hsts{display:flex;gap:0;padding-top:44px;border-top:1px solid var(--border)}
.hst{flex:1}
.hst+.hst{padding-left:28px;border-left:1px solid var(--border);margin-left:28px}
.hstn{font-family:var(--serif);font-size:clamp(26px,3.5vw,44px);line-height:1;margin-bottom:5px;font-weight:900;background:linear-gradient(135deg,var(--or),var(--dor));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.hstl{font-size:11px;color:var(--muted);font-weight:600;letter-spacing:.5px;text-transform:uppercase}

/* hero floating badge */
.hbadge{position:absolute;background:rgba(255,252,249,.92);backdrop-filter:blur(16px);border:1px solid var(--border2);border-radius:20px;padding:16px 22px;box-shadow:0 16px 48px rgba(248,108,61,.18);animation:hbf 4s ease-in-out infinite}
@keyframes hbf{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
.hbadge1{bottom:15%;left:-5%}
.hbadge2{top:25%;right:-4%}
.hbnum{font-family:var(--serif);font-size:28px;font-weight:900;line-height:1;background:linear-gradient(135deg,var(--or),var(--dor));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.hblbl{font-size:11px;color:var(--muted);font-weight:600;margin-top:3px}

/* ── SERVICES ────────────────────────────────────────────────────────────── */
.svsec{padding:140px 44px;max-width:1280px;margin:0 auto}
.svhd{display:grid;grid-template-columns:1fr 1fr;gap:60px;align-items:end;margin-bottom:80px}
.svhd h2{font-family:var(--serif);font-size:clamp(34px,4.5vw,60px);line-height:1.08;font-weight:900}
.svhd p{font-size:16px;color:var(--muted);line-height:1.85}
.svlm{margin-top:22px;display:inline-flex;align-items:center;gap:8px;font-size:14px;font-weight:700;color:var(--or);cursor:pointer;transition:gap .2s}
.svlm:hover{gap:14px}
.svg{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.svc{position:relative;border:1px solid var(--border);border-radius:24px;padding:48px 36px 44px;background:var(--white);overflow:hidden;transition:border-color .3s,transform .4s var(--sp),box-shadow .4s;cursor:default}
.svc::before{content:"";position:absolute;inset:0;background:linear-gradient(135deg,var(--ot),transparent 60%);opacity:0;transition:opacity .4s}
.svc::after{content:"";position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--or),var(--sor));transform:scaleX(0);transform-origin:left;transition:transform .4s var(--ez)}
.svc:hover{border-color:var(--border2);transform:translateY(-10px);box-shadow:0 28px 72px rgba(248,108,61,.12)}
.svc:hover::before{opacity:1}
.svc:hover::after{transform:scaleX(1)}
.svcn{position:absolute;top:20px;right:24px;font-family:var(--serif);font-size:72px;line-height:1;color:var(--border);pointer-events:none;transition:color .3s}
.svc:hover .svcn{color:rgba(248,108,61,.07)}
.svci{width:56px;height:56px;background:var(--ot);border-radius:16px;display:flex;align-items:center;justify-content:center;margin-bottom:28px;font-size:26px;transition:background .3s,transform .4s var(--sp)}
.svc:hover .svci{background:linear-gradient(135deg,var(--or),var(--dor));transform:scale(1.12) rotate(-5deg)}
.svc h3{font-family:var(--serif);font-size:22px;line-height:1.22;margin-bottom:14px;color:var(--ink);font-weight:700}
.svc p{font-size:14px;color:var(--muted);line-height:1.85;margin-bottom:24px}
.svtg{display:flex;flex-wrap:wrap;gap:7px}
.svt{font-size:11px;font-weight:700;letter-spacing:.5px;color:var(--dor);background:var(--ot);border:1px solid var(--border2);padding:4px 12px;border-radius:100px}
.svca{position:absolute;bottom:28px;right:28px;width:36px;height:36px;border-radius:50%;border:1.5px solid var(--border);display:flex;align-items:center;justify-content:center;color:var(--muted2);transition:all .3s var(--sp)}
.svc:hover .svca{background:linear-gradient(135deg,var(--or),var(--dor));border-color:var(--or);color:#fff;transform:rotate(45deg)}

/* ── CLIENT STORIES ──────────────────────────────────────────────────────── */
.sts-sec{padding-bottom:140px;background:var(--surf)}
.sts-in{max-width:1320px;margin:0 auto;padding:120px 44px 0}
.sts-hd{text-align:center;margin-bottom:80px}
.sts-hd h2{font-family:var(--serif);font-size:clamp(34px,4vw,56px);line-height:1.1;margin-top:14px;font-weight:900}
.sts-vp{overflow:hidden;width:100%}
.sts-trk{display:flex;width:100%;transition:transform .75s cubic-bezier(.77,0,.175,1);will-change:transform}
.sts-page{display:flex;gap:24px;width:100%;flex-shrink:0;min-height:380px;padding:4px 2px}

/* story group — desktop: row, mobile: column */
.sg{flex:1;display:flex;gap:12px;min-height:380px;min-width:0}

/* logo card */
.sc-lg{flex-shrink:0;width:200px;border-radius:22px;padding:30px 22px;display:flex;flex-direction:column;justify-content:space-between;box-shadow:0 12px 48px rgba(0,0,0,.18);transition:transform .5s var(--sp),box-shadow .5s;position:relative;overflow:hidden}
.sc-lg::after{content:"";position:absolute;top:-30%;right:-20%;width:140%;height:140%;background:radial-gradient(circle at 75% 15%,rgba(255,255,255,.1),transparent 60%);pointer-events:none}
.sc-lg:hover{transform:translateY(-8px) scale(1.01);box-shadow:0 32px 72px rgba(0,0,0,.28)}

/* metrics stack */
.sc-ms{flex-shrink:0;width:155px;display:flex;flex-direction:column;gap:10px}
.sc-mt{border-radius:22px;padding:22px 18px;flex:1;display:flex;flex-direction:column;justify-content:center;box-shadow:0 8px 32px rgba(0,0,0,.15);transition:transform .45s var(--sp);position:relative;overflow:hidden}
.sc-mt::after{content:"";position:absolute;bottom:-20%;right:-20%;width:120%;height:120%;background:radial-gradient(circle,rgba(255,255,255,.07),transparent 60%);pointer-events:none}
.sc-mt:hover{transform:translateY(-5px)}
.sc-mb{border-radius:22px;padding:18px;box-shadow:0 8px 28px rgba(0,0,0,.14);transition:transform .45s var(--sp)}
.sc-mb:hover{transform:translateY(-4px)}
.sc-ml{font-size:10px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:rgba(255,255,255,.52);margin-bottom:5px}
.sc-mn{font-family:var(--serif);font-size:52px;font-weight:900;line-height:.9;color:#fff;letter-spacing:-1px;text-shadow:0 4px 20px rgba(0,0,0,.25)}
.sc-mdr{font-family:var(--serif);font-size:26px;font-weight:900;line-height:1.1;color:#fff;margin-top:2px}
.sc-svcs{margin-top:8px}
.sc-svcs li{font-size:11px;color:rgba(255,255,255,.75);padding:2px 0;font-weight:500}

/* shared card text */
.sc-circle{width:66px;height:66px;border-radius:50%;background:rgba(255,255,255,.18);border:2.5px solid rgba(255,255,255,.32);display:flex;align-items:center;justify-content:center;font-family:var(--serif);font-size:22px;font-weight:700;color:#fff;margin-bottom:18px;box-shadow:0 4px 16px rgba(0,0,0,.15)}
.sc-nm{font-family:var(--serif);font-size:21px;font-weight:700;line-height:1.2;color:#fff;margin-bottom:4px}
.sc-cy{font-size:11px;color:rgba(255,255,255,.6);font-weight:500;margin-bottom:10px}
.sc-dv{height:1px;background:rgba(255,255,255,.2);margin-bottom:9px}
.sc-ct{font-size:10px;font-weight:700;letter-spacing:1.2px;text-transform:uppercase;color:rgba(255,255,255,.5);margin-bottom:7px}
.sc-ds{font-size:11.5px;color:rgba(255,255,255,.72);line-height:1.65;flex:1}
.sc-chs{display:flex;flex-wrap:wrap;gap:5px;margin-top:14px}
.sc-ch{font-size:10px;font-weight:700;border:1px solid rgba(255,255,255,.28);border-radius:100px;padding:3px 9px;color:rgba(255,255,255,.78);transition:background .2s}
.sc-ch:hover{background:rgba(255,255,255,.18)}

/* image card */
.sc-im{flex:1;min-width:0;border-radius:22px;overflow:hidden;position:relative;box-shadow:0 12px 48px rgba(0,0,0,.16);cursor:pointer}
.sc-im img{width:100%;height:100%;object-fit:cover;transition:transform .7s var(--ez);display:block}
.sc-im:hover img{transform:scale(1.07)}
.sc-im-ov{position:absolute;inset:0;background:linear-gradient(to top,rgba(0,0,0,.6) 0%,rgba(0,0,0,.1) 45%,transparent 65%);transition:opacity .3s}
.sc-im:hover .sc-im-ov{opacity:.72}
.sc-im-tag{position:absolute;bottom:18px;left:18px;background:rgba(248,108,61,.18);backdrop-filter:blur(12px);border:1px solid rgba(248,108,61,.4);border-radius:100px;padding:6px 14px;font-size:11px;font-weight:700;color:#fff;letter-spacing:.5px;transition:background .25s}
.sc-im:hover .sc-im-tag{background:rgba(248,108,61,.35)}

/* slider nav */
.sts-nav{display:flex;gap:10px;margin-top:32px;justify-content:center;align-items:center}
.sts-nb{width:46px;height:46px;border-radius:50%;border:1.5px solid var(--border2);background:var(--white);cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--or);transition:all .25s var(--sp);box-shadow:0 2px 16px rgba(248,108,61,.08);flex-shrink:0}
.sts-nb:hover{background:linear-gradient(135deg,var(--or),var(--dor));border-color:var(--or);color:#fff;transform:scale(1.1)}
.sts-dt{height:8px;border-radius:100px;border:none;cursor:pointer;background:var(--border);transition:background .3s,width .3s;padding:0;flex-shrink:0;min-width:8px}
.sts-dt.on{background:linear-gradient(90deg,var(--or),var(--sor))}

/* ── CLIENT LOGOS ────────────────────────────────────────────────────────── */
.clsec{background:var(--cream);padding:120px 44px}
.clin{max-width:1280px;margin:0 auto}
.clhd{text-align:center;margin-bottom:68px}
.clhd h2{font-family:var(--serif);font-size:clamp(32px,4vw,54px);line-height:1.1;margin-top:14px;font-weight:900}
.clg{display:grid;grid-template-columns:repeat(6,1fr);gap:13px;margin-bottom:52px}
.clc{background:var(--white);border:1px solid var(--border);border-radius:16px;padding:22px 13px;display:flex;flex-direction:column;align-items:center;gap:10px;transition:border-color .3s,transform .35s var(--sp),box-shadow .35s;cursor:pointer}
.clc:hover{border-color:var(--border2);transform:translateY(-5px);box-shadow:0 14px 40px rgba(248,108,61,.12)}
.clb{width:60px;height:60px;border-radius:12px;background:var(--surf);overflow:hidden;display:flex;align-items:center;justify-content:center;padding:7px;transition:transform .35s var(--sp)}
.clc:hover .clb{transform:scale(1.14)}
.clb img{width:100%;height:100%;object-fit:contain}
.clfb{width:100%;height:100%;background:linear-gradient(135deg,var(--or),var(--dor));border-radius:8px;display:flex;align-items:center;justify-content:center;color:#fff;font-family:var(--serif);font-size:16px;font-weight:700}
.cln{font-size:10px;font-weight:700;color:var(--muted2);text-align:center;line-height:1.3;letter-spacing:.3px}
.clt{display:flex;border-radius:20px;overflow:hidden;border:1px solid var(--border);background:var(--white)}
.cttm{flex:1;padding:32px 22px;text-align:center;border-right:1px solid var(--border)}
.cttm:last-child{border-right:none}
.cttn{font-family:var(--serif);font-size:clamp(24px,3vw,38px);line-height:1;margin-bottom:6px;font-weight:900;background:linear-gradient(135deg,var(--or),var(--dor));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.cttl{font-size:11px;color:var(--muted2);font-weight:700;letter-spacing:.5px;text-transform:uppercase}

/* ── INSTA ───────────────────────────────────────────────────────────────── */
.isec{padding:120px 0;background:var(--dark);overflow:hidden}
.iin{max-width:1280px;margin:0 auto;padding:0 44px}
.ihd{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:52px;flex-wrap:wrap;gap:24px}
.ihd h2{font-family:var(--serif);font-size:clamp(30px,4vw,52px);color:#fff;line-height:1.1;font-weight:900}
.ihd p{color:rgba(255,230,210,.42);font-size:15px;line-height:1.75;max-width:340px}
.isl{overflow:hidden}
.itr{display:flex;gap:20px;transition:transform .65s var(--ez);will-change:transform}
.ic{flex-shrink:0;width:275px;border-radius:20px;overflow:hidden;background:#180E08;border:1px solid rgba(248,108,61,.1);transition:transform .35s var(--sp),border-color .3s}
.ic:hover{transform:scale(1.03);border-color:rgba(248,108,61,.4)}
.icimg{width:100%;height:195px;object-fit:cover}
.icb{padding:18px 18px 20px}
.icp{display:flex;align-items:center;gap:10px;margin-bottom:12px}
.icav{width:34px;height:34px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:#fff;background:linear-gradient(135deg,var(--or),var(--dor));border:2px solid rgba(248,108,61,.3)}
.ich{font-size:13px;font-weight:700;color:#fff}
.icf{font-size:11px;color:rgba(255,200,160,.38);margin-top:1px}
.icc{font-size:12px;color:rgba(255,200,160,.52);line-height:1.65}
.ict{display:inline-block;margin-top:10px;font-size:10px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--sor);background:rgba(248,108,61,.1);border:1px solid rgba(248,108,61,.25);border-radius:100px;padding:3px 10px}
.inv{display:flex;align-items:center;gap:8px;margin-top:28px}
.inb{width:42px;height:42px;border-radius:50%;border:1px solid rgba(248,108,61,.2);background:rgba(248,108,61,.05);cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--sor);transition:all .25s}
.inb:hover{border-color:var(--or);background:var(--or);color:#fff}
.ind{height:8px;border-radius:100px;border:none;cursor:pointer;background:rgba(248,108,61,.2);transition:background .3s,width .3s;padding:0;flex-shrink:0;min-width:8px}
.ind.on{background:linear-gradient(90deg,var(--or),var(--sor))}

/* ── ABOUT ───────────────────────────────────────────────────────────────── */
.about{padding:140px 44px;max-width:1280px;margin:0 auto}
.abh{text-align:center;margin-bottom:88px}
.abh h2{font-family:var(--serif);font-size:clamp(34px,4vw,56px);line-height:1.1;font-weight:900;margin-top:14px}
.abh p{font-size:17px;color:var(--muted);max-width:540px;margin:16px auto 0;line-height:1.85}

/* CEO card */
.ceo{display:grid;grid-template-columns:440px 1fr;border-radius:32px;overflow:hidden;box-shadow:0 40px 100px rgba(248,108,61,.12),0 8px 32px rgba(0,0,0,.08);margin-bottom:60px;min-height:540px;border:1px solid var(--border)}
.ceo-iw{position:relative;overflow:hidden;background:var(--surf)}
.ceo-img{width:100%;height:100%;object-fit:cover;object-position:top center;display:block;min-height:540px}
.ceo-bar{position:absolute;bottom:0;left:0;right:0;background:linear-gradient(to top,rgba(10,8,6,.9) 0%,transparent 65%);padding:36px 32px 30px}
.ceo-bname{font-family:var(--serif);font-size:26px;font-weight:700;color:var(--black);line-height:1.2}
.ceo-brole{font-size:12px;font-weight:700;letter-spacing:1px;text-transform:uppercase;color:var(--sor);margin-top:5px}
.ceo-by{display:inline-flex;align-items:center;gap:6px;margin-top:12px;background:rgba(248,108,61,.15);backdrop-filter:blur(8px);border:1px solid rgba(248,108,61,.3);border-radius:100px;padding:5px 14px;font-size:11px;font-weight:700;color:#fff;letter-spacing:.5px}
.ceo-cnt{padding:56px 56px;display:flex;flex-direction:column;justify-content:center;background:var(--white)}
.ceo-bdg{display:inline-flex;align-items:center;gap:8px;background:var(--ot);border:1px solid var(--border2);border-radius:100px;padding:7px 18px;font-size:11px;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;color:var(--dor);margin-bottom:24px;width:fit-content}
.ceo-tit{font-family:var(--serif);font-size:clamp(24px,3vw,40px);line-height:1.15;font-weight:900;color:var(--ink);margin-bottom:18px}
.ceo-dc{font-size:15px;color:var(--muted);line-height:1.9;margin-bottom:15px}
.ceo-q{border-left:3px solid var(--or);padding:16px 24px;background:var(--ot2);border-radius:0 16px 16px 0;margin:24px 0 32px;position:relative}
.ceo-q::before{content:"\\201C";position:absolute;top:-10px;left:16px;font-family:var(--serif);font-size:64px;color:var(--or);opacity:.2;line-height:1}
.ceo-q p{font-family:var(--serif);font-size:16px;font-style:italic;color:var(--ink);line-height:1.65}
.ceo-q footer{font-size:11px;color:var(--or);font-weight:700;letter-spacing:.5px;text-transform:uppercase;margin-top:8px}
.ceo-ms{display:flex;gap:28px;padding-top:28px;border-top:1px solid var(--border);flex-wrap:wrap}
.ceo-m{text-align:center}
.ceo-mn{font-family:var(--serif);font-size:32px;font-weight:900;line-height:1;background:linear-gradient(135deg,var(--or),var(--dor));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.ceo-ml{font-size:10px;font-weight:700;color:var(--muted2);letter-spacing:.5px;text-transform:uppercase;margin-top:4px}

/* TEAM */
.tmg{display:grid;grid-template-columns:repeat(3,1fr);gap:20px}
.tm{display:flex;align-items:center;gap:16px;padding:22px;border:1px solid var(--border);border-radius:20px;background:var(--white);transition:border-color .3s,box-shadow .35s,transform .35s var(--sp)}
.tm:hover{border-color:var(--border2);box-shadow:0 14px 48px rgba(248,108,61,.1);transform:translateY(-5px)}
.tmav{width:62px;height:62px;border-radius:16px;display:flex;align-items:center;justify-content:center;color:#fff;font-family:var(--serif);font-size:22px;font-weight:700;flex-shrink:0}
.tmn{font-family:var(--serif);font-size:17px;color:var(--ink);font-weight:700}
.tmr{font-size:11px;color:var(--or);font-weight:700;letter-spacing:.5px;text-transform:uppercase;margin-top:2px}
.tmb{font-size:12px;color:var(--muted);margin-top:6px;line-height:1.55}
.tmbg{margin-left:auto;background:var(--surf);border:1px solid var(--border);border-radius:12px;padding:9px 14px;text-align:center;flex-shrink:0}
.tmbgn{font-family:var(--serif);font-size:19px;line-height:1;font-weight:900;background:linear-gradient(135deg,var(--or),var(--dor));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.tmbgl{font-size:9px;color:var(--muted2);font-weight:700;letter-spacing:.8px;text-transform:uppercase;margin-top:2px}

/* ── CTA ─────────────────────────────────────────────────────────────────── */
.cta{background:linear-gradient(135deg,#180A02 0%,#2A1005 50%,#0D0806 100%);padding:100px 44px;text-align:center;overflow:hidden;position:relative}
.ctabg{position:absolute;inset:0;background:repeating-linear-gradient(-45deg,rgba(248,108,61,.03) 0,rgba(248,108,61,.03) 1px,transparent 1px,transparent 22px)}
.ctac1{position:absolute;width:600px;height:600px;border-radius:50%;background:radial-gradient(circle,rgba(248,108,61,.15),transparent 70%);top:-200px;right:-150px;pointer-events:none;animation:ctapulse 6s ease-in-out infinite}
.ctac2{position:absolute;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(217,87,46,.1),transparent 70%);bottom:-100px;left:-80px;pointer-events:none;animation:ctapulse 8s ease-in-out infinite reverse}
@keyframes ctapulse{0%,100%{transform:scale(1)}50%{transform:scale(1.1)}}
.ctain{position:relative;max-width:680px;margin:0 auto}
.ctain h2{font-family:var(--serif);font-size:clamp(36px,5vw,64px);color:#fff;line-height:1.04;margin-bottom:20px;font-weight:900}
.ctain p{font-size:16px;color:rgba(255,200,160,.55);line-height:1.8;margin-bottom:48px}
.ctabs{display:flex;gap:16px;justify-content:center;flex-wrap:wrap}
.bwh{display:inline-flex;align-items:center;gap:8px;padding:15px 34px;border-radius:100px;background:#fff;color:var(--dor);font-family:var(--sans);font-size:14px;font-weight:700;border:none;cursor:pointer;box-shadow:0 8px 28px rgba(0,0,0,.2);transition:transform .25s var(--sp),box-shadow .25s}
.bwh:hover{transform:translateY(-3px);box-shadow:0 16px 40px rgba(0,0,0,.3)}
.bwho{display:inline-flex;align-items:center;gap:8px;padding:15px 34px;border-radius:100px;background:transparent;color:#fff;font-family:var(--sans);font-size:14px;font-weight:600;border:1.5px solid rgba(248,108,61,.5);cursor:pointer;transition:all .25s}
.bwho:hover{background:rgba(248,108,61,.15);border-color:var(--or)}


/* ════════════════════════════════════════════════
   RESPONSIVE BREAKPOINTS
════════════════════════════════════════════════ */

/* ── ≤ 1024px ────────────────────────────────── */
@media(max-width:1024px){
  .hero{grid-template-columns:1fr}
  .hr{display:none}
  .hl{padding:120px 44px 80px;max-width:none}
  .svg{grid-template-columns:repeat(2,1fr)}
  .svhd{grid-template-columns:1fr;gap:16px}
  .sc-lg{width:178px}
  .sc-ms{width:148px}
  .clg{grid-template-columns:repeat(4,1fr)}
  .ceo{grid-template-columns:340px 1fr}
  .tmg{grid-template-columns:repeat(2,1fr)}
}

/* ── ≤ 768px ────────────────────────────────── */
@media(max-width:768px){
  /* nav */
  .nl{display:none}
  .nbg{display:flex}
  .nw{padding:0 20px}

  /* hero */
  .hl{padding:90px 20px 56px}
  .ht{font-size:clamp(36px,9vw,54px)}
  .hd{font-size:15px;margin-bottom:36px}
  .hbt{gap:10px;margin-bottom:48px}
  .bp,.bg2{padding:13px 26px;font-size:13px}
  .hsts{flex-wrap:wrap;gap:16px;padding-top:32px}
  .hst+.hst{padding-left:0;border-left:none;margin-left:0;min-width:44%}

  /* services */
  .svsec{padding:72px 20px}
  .svg{grid-template-columns:1fr}
  .svhd{grid-template-columns:1fr;gap:16px;margin-bottom:48px}
  .svc{padding:36px 28px 40px}

  /* stories */
  .sts-sec{padding-bottom:80px}
  .sts-in{padding:72px 20px 0}
  .sts-hd{margin-bottom:48px}
  /* on mobile, one story per page + stacked layout */
  .sts-page{flex-direction:column;gap:16px;min-height:auto}
  .sg{flex-direction:column;gap:12px;min-height:auto}
  .sc-lg{width:100%;min-height:180px;flex-direction:row;flex-wrap:wrap;align-items:flex-start;gap:14px;padding:22px 20px}
  .sc-circle{width:52px;height:52px;font-size:18px;margin-bottom:0;flex-shrink:0}
  .sc-nm{font-size:18px}
  .sc-ms{width:100%;flex-direction:row;gap:10px}
  .sc-mt{flex:1;padding:18px 16px}
  .sc-mb{flex:1;padding:16px}
  .sc-mn{font-size:38px}
  .sc-mdr{font-size:22px}
  .sc-im{height:200px;flex:none}
  .sts-nav{flex-wrap:wrap;gap:8px;margin-top:24px}
  .sts-nb{width:42px;height:42px}

  /* logos */
  .clsec{padding:72px 20px}
  .clg{grid-template-columns:repeat(3,1fr);gap:10px}
  .clhd{margin-bottom:48px}
  .clb{width:52px;height:52px}

  /* insta */
  .isec{padding:80px 0}
  .iin{padding:0 20px}
  .ihd{margin-bottom:36px}

  /* about */
  .about{padding:72px 20px}
  .abh{margin-bottom:48px}
  .abh p{font-size:15px}
  .ceo{grid-template-columns:1fr;grid-template-rows:340px auto;min-height:auto;border-radius:24px}
  .ceo-iw{height:340px}
  .ceo-img{min-height:340px}
  .ceo-cnt{padding:32px 24px}
  .ceo-tit{font-size:clamp(20px,5vw,32px)}
  .ceo-dc{font-size:14px}
  .ceo-q p{font-size:14px}
  .ceo-ms{gap:18px}
  .ceo-mn{font-size:26px}
  .tmg{grid-template-columns:1fr}

  /* cta */
  .cta{padding:72px 20px}
  .ctain h2{font-size:clamp(30px,8vw,48px)}
  .ctain p{font-size:15px;margin-bottom:36px}
  .ctabs{flex-direction:column;align-items:center}
  .bwh,.bwho{width:100%;max-width:320px;justify-content:center;padding:16px 28px}

  /* stats bar */
  .clt{flex-direction:column;border-radius:16px}
  .cttm{border-right:none!important;border-bottom:1px solid var(--border)!important;padding:24px 16px}
  .cttm:last-child{border-bottom:none!important}
}

/* ── ≤ 480px ────────────────────────────────── */
@media(max-width:480px){
  /* hero */
  .hl{padding:80px 16px 48px}
  .ht{font-size:clamp(32px,10vw,46px)}
  .hd{font-size:14px}
  .bp,.bg2{padding:12px 22px;font-size:13px;width:100%;justify-content:center}
  .hbt{flex-direction:column}
  .htag .ptag{font-size:10px;padding:5px 14px}

  /* services */
  .svsec{padding:60px 16px}
  .svc{padding:28px 22px 36px}

  /* stories */
  .sts-in{padding:56px 16px 0}
  .sc-lg{padding:18px 16px}
  .sc-nm{font-size:16px}
  .sc-mn{font-size:32px}
  .sc-mdr{font-size:18px}

  /* logos */
  .clsec{padding:60px 16px}
  .clg{grid-template-columns:repeat(2,1fr);gap:8px}
  .clb{width:46px;height:46px}
  .cln{font-size:9px}

  /* insta */
  .iin{padding:0 16px}
  .ic{width:248px}

  /* about */
  .about{padding:60px 16px}
  .ceo-cnt{padding:24px 16px}
  .ceo-ms{gap:12px}
  .ceo-mn{font-size:22px}

  /* cta */
  .cta{padding:60px 16px}
  .ctain h2{font-size:clamp(26px,9vw,40px)}
}

/* ── ≤ 360px (very small phones) ─────────────── */
@media(max-width:360px){
  .ht{font-size:30px}
  .svg{gap:12px}
  .sc-ms{flex-direction:column}
  .clg{gap:6px}
  .ceo-iw{height:280px}
  .ceo-img{min-height:280px}
}
`;

// ── Replace StoryCard component in your file with this ─────────────────────
// This version stacks gracefully on mobile via the CSS above.
// No inline style changes needed — the CSS media queries handle it all.
// The component itself is unchanged from your original; the CSS does the work.

// ── In STORY_PAGES slider, on mobile show 1 story per page ─────────────────
// Add this helper near the top of PremiumWebsite component:
//
//   const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;
//
// Then change the STORY_PAGES build to:
//
//   const STORY_PAGES = [];
//   const perPage = isMobile ? 1 : 2;
//   for (let i = 0; i < STORIES.length; i += perPage) {
//     STORY_PAGES.push(STORIES.slice(i, i + perPage));
//   }
//
// This ensures mobile shows one story at a time instead of two side-by-side.
// For full SSR safety you can also derive it inside the component with useState + useEffect.

const SVCS=[
  {i:"📱",t:"Content Creation + Social Media",d:"We create sales-driven content through infographics, videos, reels and strategic collaborations that attract organic traffic and grow your audience.",tg:["Instagram","YouTube","LinkedIn","Reels"]},
  {i:"🎯",t:"Lead Generation + Digital Campaigns",d:"We develop marketing funnels, craft creatives & copywriting, run promotions, optimize budgets and analyze performance across all platforms.",tg:["Facebook Ads","Google Ads","Meta Ads","Analytics"]},
  {i:"🌐",t:"Corporate Branding & Web Design",d:"We create corporate identity through design expertise in branding, packaging and websites — delivering a clear brand message through creative graphics.",tg:["Logo Design","Packaging","Website","UI/UX"]},
  {i:"🔍",t:"Search Engine Optimization",d:"We drive organic search visibility with technical SEO, keyword strategy, on-page optimization and authority link building that ranks you first.",tg:["On-Page SEO","Technical SEO","Link Building","Rankings"]},
  {i:"🎨",t:"Graphic Design & Video Production",d:"From social media creatives and ad banners to promotional videos and motion graphics — visuals that stop the scroll and tell your story.",tg:["Ad Creatives","Motion Graphics","Video Editing","Branding"]},
  {i:"📊",t:"Analytics & Strategy Consulting",d:"Data-led decisions. We track every metric, build custom reports and translate numbers into actionable growth strategies immediately.",tg:["GA4","Meta Pixel","Reporting","CRO"]},
];

// const STORIES=[
//   {v:"vn",init:"ZS",n1:"Zuri",n2:"Skin Clinic",city:"Hyderabad",cat:"Health Care",desc:"Quality skin, hair & nail care with top dermatologists and cutting-edge procedures.",leads:"1000",dur:"8 Months",svcs:["Social Media","Website","Lead Gen Campaigns"],chs:["Facebook","Instagram","YouTube","Google"],img:"https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=500&h=380&fit=crop",tag:"Healthcare"},
//   {v:"vr",init:"DW",n1:"Design",n2:"Walls",city:"Hyderabad",cat:"Wall Papers & Furnishings",desc:"A leading wall paper company known for customisable designs, great collection & speedy service.",leads:"3500",dur:"8 Months",svcs:["Social Media","Website","Lead Gen"],chs:["Facebook","Instagram","YouTube","Google"],img:"https://images.unsplash.com/photo-1615873968403-89e068629265?w=500&h=380&fit=crop",tag:"Interior Design"},
//   {v:"vo1",init:"MM",n1:"Millet",n2:"Marvels",city:"Hyderabad",cat:"Food & Nutrition",desc:"MILLET EXPERIENCE HUB — serving 100% wholegrain goodness to health-conscious India.",leads:"9,621",dur:"6 Months",svcs:["Instagram Growth","Brand Collabs","Content"],chs:["Instagram","YouTube","Google"],img:"https://images.unsplash.com/photo-1586201375761-83865001e31c?w=500&h=380&fit=crop",tag:"Food Brand"},
//   {v:"vo2",init:"IS",n1:"Indic",n2:"Intl School",city:"Secunderabad",cat:"Education",desc:"Education that sets u free — engaging young minds through exciting activities and modern pedagogy.",leads:"1,096",dur:"5 Months",svcs:["Social Media","Lead Gen","Content"],chs:["Facebook","Instagram","Google"],img:"https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=500&h=380&fit=crop",tag:"Education"},
// ];
// ─── 1. STORIES DATA ───────────────────────────────────────
const STORIES = [
  {
    init:"CC", n1:"Carnival", n2:"Castle",
    city:"India", cat:"Entertainment / Events",
    desc:"A vibrant destination for events and celebrations, offering premium experiences for families and corporate gatherings.",
    leads:"2,400", dur:"6 Months",
    svcs:["Social Media","Performance Ads","Branding"],
    chs:["Instagram","Facebook","Google"],
    img:"https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=500&h=380&fit=crop",
    tag:"Entertainment",
    grad:"linear-gradient(135deg, #2a0845, #6a1b9a)",
    gradMet:"linear-gradient(145deg, #3d1264, #8b23c2)",
    gradMetB:"linear-gradient(145deg, #1e0633, #4a0f7a)",
  },
  {
    init:"GL", n1:"Green Leaves", n2:"Infra",
    city:"Hyderabad", cat:"Real Estate",
    desc:"A trusted real estate brand focused on sustainable and modern infrastructure development.",
    leads:"3,200", dur:"8 Months",
    svcs:["Lead Generation","Google Ads","Landing Pages"],
    chs:["Google","Facebook"],
    img:"https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=500&h=380&fit=crop",
    tag:"Real Estate",
    grad:"linear-gradient(135deg, #0f2027, #2e7d32)",
    gradMet:"linear-gradient(145deg, #1a3a20, #3d9142)",
    gradMetB:"linear-gradient(145deg, #0a1a0e, #1e5224)",
  },
  {
    init:"CI", n1:"Construct", n2:"Insides",
    city:"India", cat:"Interior Design",
    desc:"Experts in transforming spaces with modern interiors, premium materials, and functional design.",
    leads:"1,850", dur:"7 Months",
    svcs:["Branding","Website","Social Media"],
    chs:["Instagram","Pinterest","Google"],
    img:"https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=500&h=380&fit=crop",
    tag:"Interior",
    grad:"linear-gradient(135deg, #1c1c1c, #263238)",
    gradMet:"linear-gradient(145deg, #2a2a2a, #37474f)",
    gradMetB:"linear-gradient(145deg, #111111, #1a2327)",
  },
  {
  init:"AM",
  n1:"Amista",
  n2:"Clinic",
  city:"India",
  cat:"Skin Clinic",
  desc:"Advanced skin and aesthetic treatments with a focus on healthy, radiant skin using modern dermatology techniques.",
  leads:"2,900",
  dur:"6 Months",
  svcs:["Ads","Landing Pages","SEO"],
  chs:["Google","Facebook"],
  img:"https://plus.unsplash.com/premium_photo-1682096423780-41ca1b04af68?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8c2tpbiUyMGNhcmV8ZW58MHx8MHx8fDA%3D",
  tag:"Healthcare",

  // 🌟 BRAND GRADIENTS (UPDATED)
  grad:"linear-gradient(135deg, #0D47A1, #4FC3F7)",

  // ✨ METALLIC / CARD UI
  gradMet:"linear-gradient(145deg, #1976D2, #4FC3F7)",
  gradMetB:"linear-gradient(145deg, #0A1F3D, #1565C0)"
},
  {
    init:"KC", n1:"Kalyani", n2:"Constructions",
    city:"Hyderabad", cat:"Construction",
    desc:"Reliable construction services delivering quality projects with timely execution.",
    leads:"2,100", dur:"5 Months",
    svcs:["Lead Gen","SEO","Branding"],
    chs:["Google","Facebook"],
    img:"https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=500&h=380&fit=crop",
    tag:"Construction",
    grad:"linear-gradient(135deg, #2c0b0e, #b71c1c)",
    gradMet:"linear-gradient(145deg, #4a1216, #d32f2f)",
    gradMetB:"linear-gradient(145deg, #1a0608, #8e1010)",
  },
{
  init:"SC",
  n1:"SIA",
  n2:"Clinics",
  city:"India",
  cat:"Skin Care Clinic",
  desc:"Natural and advanced skin care treatments focused on healthy, radiant skin using modern and herbal approaches.",
  leads:"1,500",
  dur:"6 Months",
  svcs:["Social Media","Ads","Website"],
  chs:["Instagram","Google"],
  img:"https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=500&h=380&fit=crop",
  tag:"Healthcare",

  // 🌿 PRIMARY BRAND GRADIENT (NATURAL SKINCARE)
  grad:"linear-gradient(135deg, #4B6A30, #D6F240)",

  // ✨ CARD UI (SOFT + PREMIUM)
  gradMet:"linear-gradient(145deg, #6E8F3A, #D6F240)",

  // 🌑 DEPTH / HOVER
  gradMetB:"linear-gradient(145deg, #2F3F1F, #4B6A30)"
},
  {
    init:"JW", n1:"JJ Wellness", n2:"Clinic",
    city:"India", cat:"Wellness",
    desc:"Holistic wellness solutions combining modern healthcare with lifestyle improvements.",
    leads:"1,200", dur:"5 Months",
    svcs:["Content","Social Media","Ads"],
    chs:["Instagram","Facebook"],
    img:"https://images.unsplash.com/photo-1556228720-195a672e8a03?w=500&h=380&fit=crop",
    tag:"Wellness",
grad:"linear-gradient(135deg, #0f2027, #00acc1)",
    gradMet:"linear-gradient(145deg, #12303a, #00bcd4)",
    gradMetB:"linear-gradient(145deg, #081520, #007c8a)",
  },

{
  init:"RT",
  n1:"Rao Travels",
  n2:"Online",
  city:"India",
  cat:"Travel",
  desc:"Reliable travel booking services with a seamless online experience for customers.",
  leads:"2,700",
  dur:"7 Months",
  svcs:["Ads","SEO","Booking Funnel"],
  chs:["Google","Facebook"],
  img:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=500&h=380&fit=crop",
  tag:"Travel",

  // 🔴🔵 PRIMARY BRAND (balanced travel feel)
  grad:"linear-gradient(135deg, #1565C0, #E53935)",

  // ✨ CARD UI (vibrant + modern)
  gradMet:"linear-gradient(145deg, #1976D2, #EF5350)",

  // 🌑 DEPTH / HOVER
  gradMetB:"linear-gradient(145deg, #0D47A1, #B71C1C)"
},
  {
    init:"VD", n1:"Vedamsa", n2:"Infra",
    city:"India", cat:"Infrastructure",
    desc:"Delivering large-scale infrastructure projects with innovation and sustainability.",
    leads:"1,900", dur:"6 Months",
    svcs:["Branding","Ads","Website"],
    chs:["Google","LinkedIn"],
    img:"https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=500&h=380&fit=crop",
    tag:"Infrastructure",
    grad:"linear-gradient(135deg, #3e1f00, #ff6f00)",
    gradMet:"linear-gradient(145deg, #5a2e00, #ff8f00)",
    gradMetB:"linear-gradient(145deg, #261200, #c05800)",
  },
 {
  init:"NR",
  n1:"Nihira",
  n2:"Realtors",
  city:"India",
  cat:"Real Estate",
  desc:"Helping clients find dream properties with trust, transparency and expertise.",
  leads:"3,100",
  dur:"8 Months",
  svcs:["Lead Gen","Ads","SEO"],
  chs:["Google","Facebook"],
  img:"https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=500&h=380&fit=crop",
  tag:"Real Estate",

  // 🔵🟢🟠 PRIMARY BRAND (balanced real estate identity)
  grad:"linear-gradient(135deg, #1E88E5, #43A047, #FB8C00)",

  // ✨ CARD UI (premium + vibrant)
  gradMet:"linear-gradient(145deg, #1976D2, #4CAF50, #FFA726)",

  // 🌑 DEPTH / HOVER
  gradMetB:"linear-gradient(145deg, #0D47A1, #1B5E20, #E65100)"
}
];

const CLIENTS=[
  {name:"Green Leaves",logo:greenleavesLogo},{name:"Construction Insides",logo:constructionLogo2},
  {name:"Hyderabad Property",logo:HyderabadPropertyLogo},{name:"Ideal Kitchen",logo:IdealKitchenLogo},
  {name:"Nihira Realtors",logo:nihirarealtorsLogo},{name:"Old City Food Truck",logo:oldCityFoodTruckLogo},
  {name:"Orion",logo:OrionLogo},{name:"Rao Travels",logo:raoTravelsLogo},
  {name:"Vedamsa",logo:vedamsaLogo},{name:"Red Yards",logo:redYardsLogo},
  {name:"JJ Wellness Clinic",logo:jj},{name:"Amista",logo:AmistaLogo},
  {name:"SIA Clinics",logo:siaLogo},{name:"Meble",logo:mebelLogo},
  {name:"Sattva",logo:sattvaLogo},{name:"Shree Suvidha",logo:shreesuvidhaLogo},
  {name:"Carnival Castle",logo:carnivalLogo},{name:"Kalyani Constructions",logo:kalyani},
  {name:"Athidi",logo:Athidi},{name:"Bloom Therapy",logo:BloomTheropy},
  {name:"Brownie Point",logo:BrowniePoint},{name:"BVB",logo:Bvb},
  {name:"Chemistry",logo:chemistry},{name:"Chikoo & Cookie Play Zone & Party",logo:Chikoo},
  {name:"Cloud",logo:cloud},{name:"Dharva",logo:Dharva},
  {name:"KS Educational",logo:KSEducational},{name:"Lotus Diagnostics",logo:LotusDiagnostics},
  {name:"Mandi Khebab",logo:mandiKhebab},{name:"MK Decor",logo:MkDecor},
  {name:"Sedyam",logo:Sedyam},{name:"Skin Shine",logo:SkinShine},
  {name:"Vayu Clinics",logo:VayuClinics}

];

const INSTA=[
  {h:"@milletmarvels",f:"9,621 followers",cap:"Farm Fresh Millets with Natural Nutrition. Changing the way India eats — one meal a day.",tag:"Social Media Growth",img:"https://images.unsplash.com/photo-1586201375761-83865001e31c?w=280&h=195&fit=crop"},
  {h:"@indicschools",f:"1,096 followers",cap:"Education that sets u free — engaging young minds through exciting activities every day.",tag:"Education Marketing",img:"https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=280&h=195&fit=crop"},
  {h:"@triumph_hyd",f:"1,841 followers",cap:"Ride the award-winning adventure — Triumph Motorcycles Hyderabad. Own the open road.",tag:"Automotive Branding",img:"https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=280&h=195&fit=crop"},
  {h:"@designwalls_hyd",f:"3,500 leads",cap:"Soft Dark Accents in Sophisticated Styles. Premium blackout curtains & wallpapers for every home.",tag:"Interior Design Ads",img:"https://images.unsplash.com/photo-1615873968403-89e068629265?w=280&h=195&fit=crop"},
  {h:"@zuriskinclinic",f:"1,000+ leads",cap:"Awaken Your Glow — Consult with our Dermatologists for all your skin concerns. Book now.",tag:"Healthcare Campaigns",img:"https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=280&h=195&fit=crop"},
  {h:"@kanactify",f:"2K+ community",cap:"Branding Irreversible. We turn your digital mediums into lead generation machines.",tag:"Agency Portfolio",img:"https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=280&h=195&fit=crop"},
];
// const STORY_PAGES = [];
// for (let i = 0; i < STORIES.length; i += 2) {
//   STORY_PAGES.push(STORIES.slice(i, i + 2));
// }

const MQ=["Social Media Marketing","Lead Generation","Google Ads","Meta Ads","Brand Identity","Web Design","Content Creation","SEO"];

function CLCard({name,logo}){
  const[err,setErr]=useState(false);
  const i=name.split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase();
  return(
    <div className="clc">
      <div className="clb">{!err?<img src={logo} alt={name} onError={()=>setErr(true)}/>:<div className="clfb">{i}</div>}</div>
      <div className="cln">{name}</div>
    </div>
  );
}


function StoryCard({ s }) {
  return (
    <div
      className="sg"
      
    >
      {/* LOGO CARD */}
      <RevealContent delay={100}>
        <div
          className="sc-lg"
          style={{ background: s.grad, height: "100%" }}
        >
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <div className="sc-circle">{s.init}</div>
            <div className="sc-nm">{s.n1}<br />{s.n2}</div>
            <div className="sc-cy">{s.city}</div>
            <div className="sc-dv" />
            <div className="sc-ct">{s.cat}</div>
            <div className="sc-ds">{s.desc}</div>
          </div>
          <div className="sc-chs">
            {s.chs.map(c => (
              <span key={c} className="sc-ch">{c}</span>
            ))}
          </div>
        </div>
      </RevealContent>
 
      {/* METRICS STACK */}
      <RevealContent
        delay={200}
        style={{ display: "flex", flexDirection: "column", gap: "10px", flexShrink: 0, width: "155px" }}
      >
        <div className="sc-mt" style={{ background: s.gradMet }}>
          <div className="sc-ml">Leads</div>
          <div className="sc-mn">{s.leads}</div>
          <div style={{ height: "1px", background: "rgba(255,255,255,.18)", margin: "13px 0" }} />
          <div className="sc-ml">Duration</div>
          <div className="sc-mdr">{s.dur}</div>
        </div>
        <div className="sc-mb" style={{ background: s.gradMetB }}>
          <div className="sc-ml" style={{ marginBottom: "8px" }}>Services</div>
          <ul className="sc-svcs">
            {s.svcs.map(sv => <li key={sv}>{"· " + sv}</li>)}
          </ul>
        </div>
      </RevealContent>
 
      {/* IMAGE CARD */}
      <RevealContent delay={300} style={{ flex: 1, minWidth: 0 }}>
        <div className="sc-im" style={{ height: "100%" }}>
          <img src={s.img} alt={s.n1} />
          <div className="sc-im-ov" />
          <span className="sc-im-tag">{s.tag}</span>
        </div>
      </RevealContent>
    </div>
  );
}

const PremiumWebsite=()=>{
  const[stuck,setStuck]=useState(false);
  const[mOpen,setMOpen]=useState(false);
  const[page,setPage]=useState(0);
  const[iIdx,setIIdx]=useState(0);
  // const vpRef=useRef(null);
  // const[vpW,setVpW]=useState(0);
  const CW=275+20,MAX_I=INSTA.length-3
  // ,PAGES=Math.ceil(STORIES.length/2);
  // inside PremiumWebsite component, after useState declarations:
const [isMobile, setIsMobile] = useState(
  typeof window !== "undefined" && window.innerWidth <= 768
);

useEffect(() => {
  const handler = () => setIsMobile(window.innerWidth <= 768);
  window.addEventListener("resize", handler);
  return () => window.removeEventListener("resize", handler);
}, []);

const STORY_PAGES = [];
const perPage = isMobile ? 1 : 2;
for (let i = 0; i < STORIES.length; i += perPage) {
  STORY_PAGES.push(STORIES.slice(i, i + perPage));
}

  // useEffect(()=>{
  //   const m=()=>{if(vpRef.current)setVpW(vpRef.current.offsetWidth);};
  //   m();window.addEventListener("resize",m);return()=>window.removeEventListener("resize",m);
  // },[]);

  useEffect(()=>{
  const t=setInterval(()=>setPage(p=>(p+1)%STORY_PAGES.length),4800);
  return()=>clearInterval(t);
},[]);
  // // const GAP=28,gW=vpW>0?Math.floor((vpW-GAP)/2):560,shift=gW+GAP;
  // const GAP=28, gW=vpW>0?Math.floor((vpW-GAP)/2):560, shift=(gW*2)+GAP;

  // useEffect(()=>{const f=()=>setStuck(window.scrollY>60);window.addEventListener("scroll",f);return()=>window.removeEventListener("scroll",f);},[]);
  // useEffect(()=>{const t=setInterval(()=>setIIdx(p=>p>=MAX_I?0:p+1),3200);return()=>clearInterval(t);},[MAX_I]);
  // useEffect(()=>{const t=setInterval(()=>setPage(p=>(p+1)%PAGES),4800);return()=>clearInterval(t);},[PAGES]);

  const go=id=>{document.getElementById(id)?.scrollIntoView({behavior:"smooth"});setMOpen(false);};

  return(
    <div>
      <style>{G}</style>
      <NavigationIndicators/><Chatbot/>

  <Navbar/>

      {/* HERO */}
      {/* <section id="home">
        <div className="mbar" style={{marginTop:"72px"}}>
          <div className="min">{[...MQ,...MQ].map((t,i)=><span key={i} className="mi">{t}<span className="ms">★</span></span>)}</div>
        </div>
        <div className="hero">
          <div className="hl">
            <RevealContent delay={0}><div className="htag"><div className="ptag"><span className="pdot"/> #1 Digital Marketing Agency · Hyderabad</div></div></RevealContent>
            <div>
              <RevealLine delay={0}><h1 className="ht" style={{marginBottom:0}}>We Turn Your</h1></RevealLine>
              <RevealLine delay={100}><h1 className="ht" style={{marginBottom:0}}><em>Digital Mediums</em></h1></RevealLine>
              <RevealLine delay={200}><h1 className="ht" style={{marginBottom:0}}>Into Lead Generation</h1></RevealLine>
              <RevealLine delay={300}><h1 className="ht">Machines.</h1></RevealLine>
            </div>
            <RevealContent delay={400}><p className="hd">As a top digital marketing agency in Hyderabad, we research, develop strategy and create compelling content that defines your brand, builds funnels and launches campaigns that convert.</p></RevealContent>
            <RevealContent delay={500}>
              <div className="hbt">
                <button className="bp" onClick={()=>go("contact")}>Start Growing <ArrowUpRight size={16}/></button>
                <button className="bg2" onClick={()=>go("stories")}>View Case Studies</button>
              </div>
            </RevealContent>
            <RevealContent delay={600}>
              <div className="hsts">
                {[["100+","Brands Served"],["50M+","Impressions"],["6+","Years Exp."],["98%","Retention"]].map(([n,l])=>(
                  <div key={l} className="hst"><div className="hstn">{n}</div><div className="hstl">{l}</div></div>
                ))}
              </div>
            </RevealContent>
          </div>
          <div className="hr">
            <RevealImage src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=900&h=900&fit=crop" alt="team" style={{width:"100%",height:"100%"}}/>
            <div className="hro"/>
            <RevealContent delay={800}>
              <div className="hbadge hbadge1">
                <div className="hbnum">100+</div>
                <div className="hblbl">Brands Served</div>
              </div>
            </RevealContent>
            <RevealContent delay={1000}>
              <div className="hbadge hbadge2">
                <div className="hbnum">98%</div>
                <div className="hblbl">Client Retention</div>
              </div>
            </RevealContent>
          </div>
        </div>
      </section> */}
      <section id="home">
  <VideoHero
    onContact={() => go("contact")}
    onStories={() => go("stories")}
  />
</section>
  <section id="stories" className="sts-sec">
  <div className="sts-in">
    <div className="sts-hd">
      <RevealContent><div className="ptag">Success Stories</div></RevealContent>
      <RevealLine delay={100}>
        <h2 style={{fontFamily:"var(--serif)",fontSize:"clamp(34px,4vw,56px)",lineHeight:"1.1",fontWeight:900,marginTop:"14px"}}>
          Our Client <span className="gto">Stories</span>
        </h2>
      </RevealLine>
    </div>

    <div className="sts-vp">
      <div className="sts-trk" style={{transform:"translateX(-"+(page*100)+"%)"}}>
        {STORY_PAGES.map((pair, pi) => (
          <div key={pi} className="sts-page">
            {pair.map((s, si) => <StoryCard key={si} s={s} />)}
          </div>
        ))}
      </div>
    </div>

    <div className="sts-nav">
      <button className="sts-nb" onClick={()=>setPage(p=>Math.max(0,p-1))}><ChevronLeft size={18}/></button>
      <button className="sts-nb" onClick={()=>setPage(p=>Math.min(STORY_PAGES.length-1,p+1))}><ChevronRight size={18}/></button>
      {STORY_PAGES.map((_,i)=>(
        <button key={i} className={"sts-dt"+(page===i?" on":"")}
          style={{width:page===i?"28px":"8px"}} onClick={()=>setPage(i)}/>
      ))}
    </div>
  </div>
</section>

      {/* CLIENT LOGOS */}
      <section id="clients" className="clsec">
        <div className="clin">
          <div className="clhd">
            <RevealContent><div className="ptag">Our Network</div></RevealContent>
            <RevealLine delay={100}><h2 style={{fontFamily:"var(--serif)",fontSize:"clamp(32px,4vw,54px)",lineHeight:"1.1",fontWeight:900,marginTop:"14px"}}>Trusted by <span className="gto">Industry Leaders</span></h2></RevealLine>
          </div>
          <div className="clg">
            {CLIENTS.map((c,i)=><RevealContent key={c.name} delay={i*30}><CLCard name={c.name} logo={c.logo}/></RevealContent>)}
          </div>
          <RevealContent>
            <div className="clt">
              {[["100+","Brands Served"],["50M+","Impressions"],["150+","Campaigns"],["98%","Retention"]].map(([n,l])=>(
                <div key={l} className="cttm"><div className="cttn">{n}</div><div className="cttl">{l}</div></div>
              ))}
            </div>
          </RevealContent>
        </div>
      </section>
      {/* SERVICES */}
      <section id="services">
        <div className="svsec">
          <div className="svhd">
            <div>
              <RevealContent><div className="ptag">What We Do</div></RevealContent>
              <RevealLine delay={100}><h2 className="rv" style={{fontFamily:"var(--serif)",fontSize:"clamp(34px,4.5vw,60px)",lineHeight:"1.08",fontWeight:900,marginTop:"14px"}}>Services That <span className="gto">Drive Results</span></h2></RevealLine>
            </div>
            <RevealContent delay={200}>
              <p style={{fontSize:"16px",color:"var(--muted)",lineHeight:"1.85"}}>Comprehensive digital marketing — from strategy and content to paid campaigns and brand identity — all under one roof.</p>
              <div className="svlm" onClick={()=>go("contact")}>Let's build your strategy <ArrowUpRight size={16}/></div>
            </RevealContent>
          </div>
          <div className="svg">
            {SVCS.map((s,i)=>(
              <RevealContent key={i} delay={i*80}>
                <div className="svc">
                  <div className="svcn">{"0"+(i+1)}</div>
                  <div className="svci"><span>{s.i}</span></div>
                  <h3>{s.t}</h3><p>{s.d}</p>
                  <div className="svtg">{s.tg.map(t=><span key={t} className="svt">{t}</span>)}</div>
                  <div className="svca"><ArrowUpRight size={15}/></div>
                </div>
              </RevealContent>
            ))}
          </div>
        </div>
      </section>

      {/* CLIENT STORIES */}


      {/* INSTA */}
      {/* <section className="isec">
        <div className="iin">
          <div className="ihd">
            <div>
              <RevealContent><div className="ptag" style={{background:"rgba(248,108,61,.1)",borderColor:"rgba(248,108,61,.28)",color:"var(--sor)"}}>Client Instagram Pages</div></RevealContent>
              <RevealLine delay={100}><h2 style={{color:"#fff",fontFamily:"var(--serif)",fontSize:"clamp(30px,4vw,52px)",lineHeight:"1.1",fontWeight:900,marginTop:"14px"}}>Real Results,<br/><span style={{background:"linear-gradient(135deg,var(--or),var(--sor))",["-webkit-background-clip"]:"text",["-webkit-text-fill-color"]:"transparent","backgroundClip":"text"}}>Real Profiles</span></h2></RevealLine>
            </div>
            <RevealContent delay={200}><p style={{color:"rgba(255,200,160,.42)",fontSize:"15px",lineHeight:"1.75",maxWidth:"340px"}}>We manage and grow Instagram pages that convert — a live snapshot of client feeds we've built from scratch.</p></RevealContent>
          </div>
          <div className="isl">
            <div className="itr" style={{transform:"translateX(-"+(iIdx*CW)+"px)"}}>
              {INSTA.map((p,i)=>(
                <div key={i} className="ic">
                  <img className="icimg" src={p.img} alt={p.h}/>
                  <div className="icb">
                    <div className="icp">
                      <div className="icav">{p.h[1].toUpperCase()}</div>
                      <div><div className="ich">{p.h}</div><div className="icf">{p.f}</div></div>
                    </div>
                    <div className="icc">{p.cap}</div>
                    <span className="ict">{p.tag}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="inv">
            <button className="inb" onClick={()=>setIIdx(p=>Math.max(0,p-1))}><ChevronLeft size={17}/></button>
            <button className="inb" onClick={()=>setIIdx(p=>Math.min(MAX_I,p+1))}><ChevronRight size={17}/></button>
            {Array.from({length:MAX_I+1}).map((_,i)=>(
              <button key={i} className={"ind"+(iIdx===i?" on":"")} style={{width:iIdx===i?"24px":"8px"}} onClick={()=>setIIdx(i)}/>
            ))}
          </div>
        </div>
      </section> */}
      <InstagramShowcase/>
      <MediaRecognitionSection/>

      {/* ABOUT */}
      <section id="about">
        <div className="about">
          <div className="abh">
            <RevealContent><div className="ptag">About Kanactify</div></RevealContent>
            <RevealLine delay={100}><h2 style={{fontFamily:"var(--serif)",fontSize:"clamp(34px,4vw,56px)",lineHeight:"1.1",fontWeight:900,marginTop:"14px"}}>Meet the People Behind <span className="gto">Your Growth</span></h2></RevealLine>
            <RevealContent delay={200}><p>Founded in 2018, Kanactify is Hyderabad's most trusted digital marketing agency — built on strategy, creativity and measurable results.</p></RevealContent>
          </div>
          <RevealContent>
            <div className="ceo">
              <div className="ceo-iw">
                <RevealImage src={ceoImage} alt="CEO" style={{width:"100%",height:"100%"}}/>
                <div className="ceo-bar">
                  <div className="ceo-bname">Founder & CEO</div>
                  <div className="ceo-bname">Mohan sushil</div>
                  <div className="ceo-brole">Chief Executive Officer · Kanactify</div>
                  <div className="ceo-by">📅 Est. 2020 · Hyderabad</div>
                </div>
              </div>
              <div className="ceo-cnt">
                <div className="ceo-bdg">🏆 Founder & Visionary</div>
                <h2 className="ceo-tit">The Visionary Behind <span className="gto">Kanactify</span></h2>
                <p className="ceo-dc">With 6+ years of hands-on experience in digital marketing, our founder built Kanactify from the ground up with one mission — to turn every client's digital presence into a high-performing lead generation machine.</p>
                <p className="ceo-dc">Having worked with 100+ brands across healthcare, real estate, food, education and retail, expertise spans strategy, creative direction, performance marketing and brand identity — all under one roof.</p>
                <div className="ceo-q">
                  <p>"Branding is irreversible. The most powerful investment any business makes is in building a brand people remember and trust."</p>
                  <footer>—  Mohan Sushil, Kanactify</footer>
                </div>
                <div className="ceo-ms">
                  {[["6+","Years Experience"],["100+","Brands Served"],["50M+","Impressions"],["98%","Retention"]].map(([n,l])=>(
                    <div key={l} className="ceo-m"><div className="ceo-mn">{n}</div><div className="ceo-ml">{l}</div></div>
                  ))}
                </div>
              </div>
            </div>
          </RevealContent>
          {/* <div className="tmg">
            {[
              {i:"S",n:"Strategy Lead",r:"Head of Digital Campaigns",b:"Crafts data-driven campaigns across Meta, Google & YouTube — 150+ campaigns delivered.",stat:"150+",sl:"Campaigns",bg:"linear-gradient(135deg,var(--or),var(--dor))"},
              {i:"C",n:"Creative Director",r:"Brand & Design Head",b:"Leads all visual branding, packaging design and web development for client brands.",stat:"80+",sl:"Brands Designed",bg:"linear-gradient(135deg,#A04818,#6A2808)"},
              {i:"A",n:"Analytics Manager",r:"Data & Performance Lead",b:"Translates complex campaign data into clear strategies that drive measurable business growth.",stat:"5M+",sl:"Leads Tracked",bg:"linear-gradient(135deg,var(--dor),#8c2a10)"},
            ].map((m,i)=>(
              <RevealContent key={i} delay={i*120}>
                <div className="tm">
                  <div className="tmav" style={{background:m.bg}}>{m.i}</div>
                  <div style={{flex:1}}><div className="tmn">{m.n}</div><div className="tmr">{m.r}</div><div className="tmb">{m.b}</div></div>
                  <div className="tmbg"><div className="tmbgn">{m.stat}</div><div className="tmbgl">{m.sl}</div></div>
                </div>
              </RevealContent>
            ))}
          </div> */}
        </div>
      </section>

      {/* CTA */}
      <section id="contact" className="cta">
        <div className="ctabg"/><div className="ctac1"/><div className="ctac2"/>
        <RevealContent style={{position:"relative",maxWidth:"680px",margin:"0 auto"}}>
          <div className="ptag" style={{background:"rgba(255,255,255,.07)",borderColor:"rgba(255,255,255,.18)",color:"rgba(255,200,160,.8)",marginBottom:"24px"}}>Ready to Grow?</div>
          <h2 style={{fontFamily:"var(--serif)",fontSize:"clamp(36px,5vw,64px)",color:"#fff",lineHeight:"1.04",marginBottom:"20px",fontWeight:900}}>Let's Turn Your Brand Into a <em style={{fontStyle:"italic",color:"var(--sor)"}}>Lead Machine</em></h2>
          <p style={{fontSize:"16px",color:"rgba(255,200,160,.55)",lineHeight:"1.8",marginBottom:"48px"}}>Join 200+ businesses across Hyderabad who trust Kanactify to grow their digital presence and generate quality leads every single month.</p>
          <div className="ctabs">
            <a className="bwh" href="tel:+919021076873">📞 Call Us Now</a>
            <a className="bwho" href="https://wa.me/919021076873" target="_blank" rel="noreferrer">💬 WhatsApp Us</a>
          </div>
        </RevealContent>
      </section>

      <ContactSection/>
      <PremiumFooter/>
    </div>
  );
};

export default PremiumWebsite;